(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("DPlayer", [], factory);
	else if(typeof exports === 'object')
		exports["DPlayer"] = factory();
	else
		root["DPlayer"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 5);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * xhr.status ---> fail
 * response.code === 1 ---> success
 * response.code !== 1 ---> error
 * */

var SendXMLHttpRequest = function SendXMLHttpRequest(url, data, success, error, fail) {
  var xhr = new XMLHttpRequest();

  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      if (xhr.status >= 200 && xhr.status < 300 || xhr.status === 304) {
        var response = JSON.parse(xhr.responseText);

        if (response.code !== 1) {
          return error(xhr, response);
        }

        return success(xhr, response);
      }

      fail(xhr);
    }
  };

  xhr.open(data !== null ? 'POST' : 'GET', url, true);
  xhr.send(data !== null ? JSON.stringify(data) : null);
};

var send = exports.send = function send(endpoint, danmakuData) {
  SendXMLHttpRequest(endpoint, danmakuData, function (xhr, response) {
    console.log('Post danmaku: ', response);
  }, function (xhr, response) {
    alert(response.msg);
  }, function (xhr) {
    console.log('Request was unsuccessful: ' + xhr.status);
  });
};

var read = exports.read = function read(endpoint, cbk) {
  SendXMLHttpRequest(endpoint, null, function (xhr, response) {
    cbk(null, response.danmaku);
  }, function (xhr, response) {
    cbk({ status: xhr.status, response: response });
  }, function (xhr) {
    cbk({ status: xhr.status, response: null });
  });
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(4)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/css-loader/index.js!../node_modules/postcss-loader/index.js!../node_modules/sass-loader/lib/loader.js!./DPlayer.scss", function() {
			var newContent = require("!!../node_modules/css-loader/index.js!../node_modules/postcss-loader/index.js!../node_modules/sass-loader/lib/loader.js!./DPlayer.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
// imports


// module
exports.push([module.i, ".dplayer {\n  position: relative;\n  overflow: hidden;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  line-height: 1; }\n  .dplayer:-webkit-full-screen {\n    width: 100% !important;\n    height: 100% !important;\n    background: #000; }\n    .dplayer:-webkit-full-screen .dplayer-danmaku .dplayer-danmaku-top.dplayer-danmaku-move,\n    .dplayer:-webkit-full-screen .dplayer-danmaku .dplayer-danmaku-bottom.dplayer-danmaku-move {\n      -webkit-animation: danmaku-center 6s linear;\n              animation: danmaku-center 6s linear;\n      -webkit-animation-play-state: paused;\n              animation-play-state: paused; }\n    .dplayer:-webkit-full-screen .dplayer-danmaku .dplayer-danmaku-right.dplayer-danmaku-move {\n      -webkit-animation: danmaku 8s linear;\n              animation: danmaku 8s linear;\n      -webkit-animation-play-state: paused;\n              animation-play-state: paused; }\n  .dplayer.dplayer-no-danmaku .dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-box {\n    height: 60px; }\n  .dplayer.dplayer-no-danmaku .dplayer-controller .dplayer-icons .dplayer-comment {\n    display: none; }\n  .dplayer.dplayer-no-danmaku .dplayer-danmaku {\n    display: none; }\n  .dplayer.dplayer-playing .dplayer-danmaku .dplayer-danmaku-move {\n    -webkit-animation-play-state: running !important;\n            animation-play-state: running !important; }\n  @media (min-width: 900px) {\n    .dplayer.dplayer-playing .dplayer-controller-mask {\n      opacity: 0; }\n    .dplayer.dplayer-playing .dplayer-controller {\n      opacity: 0; }\n    .dplayer.dplayer-playing:hover .dplayer-controller-mask {\n      opacity: 1; }\n    .dplayer.dplayer-playing:hover .dplayer-controller {\n      opacity: 1; } }\n  .dplayer.dplayer-loading .dplayer-bezel .diplayer-loading-icon {\n    display: block; }\n  .dplayer.dplayer-loading .dplayer-danmaku .dplayer-danmaku-move {\n    -webkit-animation-play-state: paused !important;\n            animation-play-state: paused !important; }\n  .dplayer.dplayer-hide-controller .dplayer-controller-mask {\n    opacity: 0;\n    -webkit-transform: translateY(100%);\n            transform: translateY(100%); }\n  .dplayer.dplayer-hide-controller .dplayer-controller {\n    opacity: 0;\n    -webkit-transform: translateY(100%);\n            transform: translateY(100%); }\n  .dplayer.dplayer-show-controller .dplayer-controller-mask {\n    opacity: 1; }\n  .dplayer.dplayer-show-controller .dplayer-controller {\n    opacity: 1; }\n  .dplayer .dplayer-mask {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 1;\n    display: none; }\n    .dplayer .dplayer-mask.dplayer-mask-show {\n      display: block; }\n  .dplayer .dplayer-video-wrap {\n    position: relative;\n    background: #000;\n    font-size: 0;\n    width: 100%;\n    height: 100%; }\n    .dplayer .dplayer-video-wrap .dplayer-video {\n      width: 100%;\n      height: 100%; }\n  .dplayer .dplayer-danmaku {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    font-size: 22px;\n    color: #fff; }\n    .dplayer .dplayer-danmaku .dplayer-danmaku-item {\n      display: inline-block;\n      pointer-events: none;\n      -webkit-user-select: none;\n         -moz-user-select: none;\n          -ms-user-select: none;\n              user-select: none;\n      cursor: default;\n      white-space: nowrap;\n      font-weight: bolder;\n      text-shadow: 0.5px 0.5px 0.5px rgba(0, 0, 0, 0.5); }\n      .dplayer .dplayer-danmaku .dplayer-danmaku-item--demo {\n        position: absolute;\n        visibility: hidden; }\n    .dplayer .dplayer-danmaku .dplayer-danmaku-right {\n      position: absolute;\n      right: 0;\n      -webkit-transform: translateX(100%);\n              transform: translateX(100%); }\n      .dplayer .dplayer-danmaku .dplayer-danmaku-right.dplayer-danmaku-move {\n        will-change: transform;\n        -webkit-animation: danmaku 5s linear;\n                animation: danmaku 5s linear;\n        -webkit-animation-play-state: paused;\n                animation-play-state: paused; }\n\n@-webkit-keyframes danmaku {\n  from {\n    -webkit-transform: translateX(100%);\n            transform: translateX(100%); } }\n\n@keyframes danmaku {\n  from {\n    -webkit-transform: translateX(100%);\n            transform: translateX(100%); } }\n    .dplayer .dplayer-danmaku .dplayer-danmaku-top,\n    .dplayer .dplayer-danmaku .dplayer-danmaku-bottom {\n      position: absolute;\n      width: 100%;\n      text-align: center;\n      visibility: hidden; }\n      .dplayer .dplayer-danmaku .dplayer-danmaku-top.dplayer-danmaku-move,\n      .dplayer .dplayer-danmaku .dplayer-danmaku-bottom.dplayer-danmaku-move {\n        will-change: visibility;\n        -webkit-animation: danmaku-center 4s linear;\n                animation: danmaku-center 4s linear;\n        -webkit-animation-play-state: paused;\n                animation-play-state: paused; }\n\n@-webkit-keyframes danmaku-center {\n  from {\n    visibility: visible; }\n  to {\n    visibility: visible; } }\n\n@keyframes danmaku-center {\n  from {\n    visibility: visible; }\n  to {\n    visibility: visible; } }\n  .dplayer .dplayer-bezel {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    font-size: 22px;\n    color: #fff;\n    pointer-events: none; }\n    .dplayer .dplayer-bezel .dplayer-fill {\n      fill: rgba(255, 255, 255, 0.8); }\n    .dplayer .dplayer-bezel .dplayer-bezel-icon {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      margin: -26px 0 0 -26px;\n      height: 52px;\n      width: 52px;\n      padding: 12px;\n      box-sizing: border-box;\n      background: rgba(0, 0, 0, 0.5);\n      border-radius: 50%;\n      opacity: 0;\n      pointer-events: none; }\n      .dplayer .dplayer-bezel .dplayer-bezel-icon.dplayer-bezel-transition {\n        -webkit-animation: bezel-hide .5s linear;\n                animation: bezel-hide .5s linear; }\n\n@-webkit-keyframes bezel-hide {\n  from {\n    opacity: 1;\n    -webkit-transform: scale(1);\n            transform: scale(1); }\n  to {\n    opacity: 0;\n    -webkit-transform: scale(2);\n            transform: scale(2); } }\n\n@keyframes bezel-hide {\n  from {\n    opacity: 1;\n    -webkit-transform: scale(1);\n            transform: scale(1); }\n  to {\n    opacity: 0;\n    -webkit-transform: scale(2);\n            transform: scale(2); } }\n    .dplayer .dplayer-bezel .dplayer-danloading {\n      position: absolute;\n      top: 50%;\n      margin-top: -7px;\n      width: 100%;\n      text-align: center;\n      font-size: 14px;\n      line-height: 14px;\n      -webkit-animation: my-face 5s infinite ease-in-out;\n              animation: my-face 5s infinite ease-in-out; }\n    .dplayer .dplayer-bezel .diplayer-loading-icon {\n      display: none;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      margin: -18px 0 0 -18px;\n      height: 36px;\n      width: 36px;\n      pointer-events: none; }\n      .dplayer .dplayer-bezel .diplayer-loading-icon .diplayer-loading-hide {\n        display: none; }\n      .dplayer .dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot {\n        -webkit-animation: diplayer-loading-dot-fade .8s ease infinite;\n                animation: diplayer-loading-dot-fade .8s ease infinite;\n        opacity: 0;\n        fill: #fff;\n        -webkit-transform-origin: 4px 4px;\n                transform-origin: 4px 4px; }\n        .dplayer .dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot.diplayer-loading-dot-7 {\n          -webkit-animation-delay: 0.7s;\n                  animation-delay: 0.7s; }\n        .dplayer .dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot.diplayer-loading-dot-6 {\n          -webkit-animation-delay: 0.6s;\n                  animation-delay: 0.6s; }\n        .dplayer .dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot.diplayer-loading-dot-5 {\n          -webkit-animation-delay: 0.5s;\n                  animation-delay: 0.5s; }\n        .dplayer .dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot.diplayer-loading-dot-4 {\n          -webkit-animation-delay: 0.4s;\n                  animation-delay: 0.4s; }\n        .dplayer .dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot.diplayer-loading-dot-3 {\n          -webkit-animation-delay: 0.3s;\n                  animation-delay: 0.3s; }\n        .dplayer .dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot.diplayer-loading-dot-2 {\n          -webkit-animation-delay: 0.2s;\n                  animation-delay: 0.2s; }\n        .dplayer .dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot.diplayer-loading-dot-1 {\n          -webkit-animation-delay: 0.1s;\n                  animation-delay: 0.1s; }\n\n@-webkit-keyframes diplayer-loading-dot-fade {\n  0% {\n    opacity: .7;\n    -webkit-transform: scale(1.2, 1.2);\n            transform: scale(1.2, 1.2); }\n  50% {\n    opacity: .25;\n    -webkit-transform: scale(0.9, 0.9);\n            transform: scale(0.9, 0.9); }\n  to {\n    opacity: .25;\n    -webkit-transform: scale(0.85, 0.85);\n            transform: scale(0.85, 0.85); } }\n\n@keyframes diplayer-loading-dot-fade {\n  0% {\n    opacity: .7;\n    -webkit-transform: scale(1.2, 1.2);\n            transform: scale(1.2, 1.2); }\n  50% {\n    opacity: .25;\n    -webkit-transform: scale(0.9, 0.9);\n            transform: scale(0.9, 0.9); }\n  to {\n    opacity: .25;\n    -webkit-transform: scale(0.85, 0.85);\n            transform: scale(0.85, 0.85); } }\n  .dplayer .dplayer-controller-mask {\n    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAADGCAYAAAAT+OqFAAAAdklEQVQoz42QQQ7AIAgEF/T/D+kbq/RWAlnQyyazA4aoAB4FsBSA/bFjuF1EOL7VbrIrBuusmrt4ZZORfb6ehbWdnRHEIiITaEUKa5EJqUakRSaEYBJSCY2dEstQY7AuxahwXFrvZmWl2rh4JZ07z9dLtesfNj5q0FU3A5ObbwAAAABJRU5ErkJggg==) repeat-x bottom;\n    height: 98px;\n    width: 100%;\n    position: absolute;\n    bottom: 0;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease; }\n  .dplayer .dplayer-controller {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 41px;\n    padding: 0 20px;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease; }\n    .dplayer .dplayer-controller .dplayer-bar-wrap {\n      padding: 5px 0;\n      cursor: pointer;\n      position: absolute;\n      bottom: 33px;\n      width: calc(100% - 40px);\n      height: 3px; }\n      .dplayer .dplayer-controller .dplayer-bar-wrap:hover .dplayer-thumb {\n        -webkit-transform: scale(1) !important;\n                transform: scale(1) !important; }\n      .dplayer .dplayer-controller .dplayer-bar-wrap .dplayer-bar {\n        position: relative;\n        height: 3px;\n        width: 100%;\n        background: rgba(255, 255, 255, 0.2);\n        cursor: pointer !important; }\n        .dplayer .dplayer-controller .dplayer-bar-wrap .dplayer-bar .dplayer-loaded {\n          position: absolute;\n          left: 0;\n          top: 0;\n          bottom: 0;\n          background: rgba(255, 255, 255, 0.4);\n          height: 3px;\n          -webkit-transition: all 0.5s ease;\n          transition: all 0.5s ease;\n          will-change: width; }\n        .dplayer .dplayer-controller .dplayer-bar-wrap .dplayer-bar .dplayer-played {\n          position: absolute;\n          left: 0;\n          top: 0;\n          bottom: 0;\n          height: 3px;\n          will-change: width; }\n          .dplayer .dplayer-controller .dplayer-bar-wrap .dplayer-bar .dplayer-played .dplayer-thumb {\n            position: absolute;\n            top: 0;\n            right: 5px;\n            margin-top: -4px;\n            margin-right: -10px;\n            height: 11px;\n            width: 11px;\n            border-radius: 50%;\n            cursor: pointer !important;\n            -webkit-transition: all .3s ease-in-out;\n            transition: all .3s ease-in-out;\n            -webkit-transform: scale(0);\n                    transform: scale(0); }\n    .dplayer .dplayer-controller .dplayer-icons {\n      height: 38px;\n      position: absolute;\n      bottom: 0; }\n      .dplayer .dplayer-controller .dplayer-icons.dplayer-icons-left .dplayer-icon {\n        padding: 7px; }\n      .dplayer .dplayer-controller .dplayer-icons.dplayer-icons-right {\n        right: 20px; }\n        .dplayer .dplayer-controller .dplayer-icons.dplayer-icons-right .dplayer-icon {\n          padding: 8px; }\n      .dplayer .dplayer-controller .dplayer-icons #dplayer-menu {\n        stroke: #ddd;\n        stroke-width: 1px; }\n      .dplayer .dplayer-controller .dplayer-icons .dplayer-time {\n        line-height: 38px;\n        color: #eee;\n        text-shadow: 0 0 2px rgba(0, 0, 0, 0.5);\n        vertical-align: middle;\n        font-size: 13px;\n        cursor: default; }\n      .dplayer .dplayer-controller .dplayer-icons .dplayer-icon {\n        width: 46px;\n        height: 100%;\n        border: none;\n        background-color: transparent;\n        outline: none;\n        cursor: pointer;\n        opacity: .8;\n        -webkit-transition: all .2s ease-in-out;\n        transition: all .2s ease-in-out;\n        vertical-align: middle;\n        box-sizing: border-box;\n        display: inline-block; }\n        .dplayer .dplayer-controller .dplayer-icons .dplayer-icon:hover {\n          opacity: 1; }\n        .dplayer .dplayer-controller .dplayer-icons .dplayer-icon.dplayer-comment-icon {\n          padding: 10px 9px 9px; }\n        .dplayer .dplayer-controller .dplayer-icons .dplayer-icon.dplayer-setting-icon {\n          padding-top: 8.5px; }\n      .dplayer .dplayer-controller .dplayer-icons .dplayer-fill {\n        fill: #fff; }\n      .dplayer .dplayer-controller .dplayer-icons .dplayer-volume {\n        position: relative;\n        display: inline-block;\n        cursor: pointer !important;\n        height: 100%; }\n        .dplayer .dplayer-controller .dplayer-icons .dplayer-volume:hover .dplayer-volume-bar {\n          width: 45px !important; }\n        .dplayer .dplayer-controller .dplayer-icons .dplayer-volume:hover .dplayer-thumb {\n          -webkit-transform: scale(1) !important;\n                  transform: scale(1) !important; }\n        .dplayer .dplayer-controller .dplayer-icons .dplayer-volume.dplayer-volume-active .dplayer-volume-bar {\n          width: 45px !important; }\n        .dplayer .dplayer-controller .dplayer-icons .dplayer-volume.dplayer-volume-active .dplayer-thumb {\n          -webkit-transform: scale(1) !important;\n                  transform: scale(1) !important; }\n        .dplayer .dplayer-controller .dplayer-icons .dplayer-volume .dplayer-volume-bar-wrap {\n          display: inline-block;\n          margin: 0 5px 0 -5px;\n          vertical-align: middle;\n          height: 100%; }\n          .dplayer .dplayer-controller .dplayer-icons .dplayer-volume .dplayer-volume-bar-wrap .dplayer-volume-bar {\n            position: relative;\n            top: 17px;\n            width: 0;\n            height: 3px;\n            background: #aaa;\n            -webkit-transition: all 0.3s ease-in-out;\n            transition: all 0.3s ease-in-out; }\n            .dplayer .dplayer-controller .dplayer-icons .dplayer-volume .dplayer-volume-bar-wrap .dplayer-volume-bar .dplayer-volume-bar-inner {\n              position: absolute;\n              bottom: 0;\n              left: 0;\n              height: 100%;\n              -webkit-transition: all 0.1s ease;\n              transition: all 0.1s ease;\n              will-change: width; }\n              .dplayer .dplayer-controller .dplayer-icons .dplayer-volume .dplayer-volume-bar-wrap .dplayer-volume-bar .dplayer-volume-bar-inner .dplayer-thumb {\n                position: absolute;\n                top: 0;\n                right: 5px;\n                margin-top: -4px;\n                margin-right: -10px;\n                height: 11px;\n                width: 11px;\n                border-radius: 50%;\n                cursor: pointer !important;\n                -webkit-transition: all .3s ease-in-out;\n                transition: all .3s ease-in-out;\n                -webkit-transform: scale(0);\n                        transform: scale(0); }\n      .dplayer .dplayer-controller .dplayer-icons .dplayer-setting {\n        display: inline-block;\n        height: 100%; }\n        .dplayer .dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-box {\n          position: absolute;\n          right: 0;\n          bottom: 50px;\n          -webkit-transform: translateX(170px);\n                  transform: translateX(170px);\n          width: 150px;\n          height: 120px;\n          border-radius: 2px;\n          background: rgba(28, 28, 28, 0.9);\n          padding: 7px 0;\n          -webkit-transition: all .3s ease-in-out;\n          transition: all .3s ease-in-out;\n          overflow: hidden;\n          z-index: 2; }\n          .dplayer .dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-box.dplayer-setting-box-open {\n            -webkit-transform: translateX(0);\n                    transform: translateX(0); }\n          .dplayer .dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-box.dplayer-setting-box-narrow {\n            width: 70px;\n            height: 180px;\n            text-align: center; }\n        .dplayer .dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-item,\n        .dplayer .dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-speed-item {\n          height: 30px;\n          padding: 5px 10px;\n          box-sizing: border-box;\n          cursor: pointer; }\n          .dplayer .dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-item:hover,\n          .dplayer .dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-speed-item:hover {\n            background-color: rgba(255, 255, 255, 0.1); }\n        .dplayer .dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-danmaku {\n          padding: 5px 0; }\n          .dplayer .dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-danmaku .dplayer-label {\n            padding: 0 10px;\n            display: inline; }\n          .dplayer .dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-danmaku:hover .dplayer-label {\n            display: none; }\n          .dplayer .dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-danmaku:hover .dplayer-danmaku-bar-wrap {\n            display: inline-block; }\n          .dplayer .dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-danmaku.dplayer-setting-danmaku-active .dplayer-label {\n            display: none; }\n          .dplayer .dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-danmaku.dplayer-setting-danmaku-active .dplayer-danmaku-bar-wrap {\n            display: inline-block; }\n          .dplayer .dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-danmaku .dplayer-danmaku-bar-wrap {\n            padding: 0 10px;\n            box-sizing: border-box;\n            display: none;\n            vertical-align: middle;\n            height: 100%;\n            width: 100%; }\n            .dplayer .dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-danmaku .dplayer-danmaku-bar-wrap .dplayer-danmaku-bar {\n              position: relative;\n              top: 8.5px;\n              width: 100%;\n              height: 3px;\n              background: #fff;\n              -webkit-transition: all 0.3s ease-in-out;\n              transition: all 0.3s ease-in-out; }\n              .dplayer .dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-danmaku .dplayer-danmaku-bar-wrap .dplayer-danmaku-bar .dplayer-danmaku-bar-inner {\n                position: absolute;\n                bottom: 0;\n                left: 0;\n                height: 100%;\n                -webkit-transition: all 0.1s ease;\n                transition: all 0.1s ease;\n                background: #aaa;\n                will-change: width; }\n                .dplayer .dplayer-controller .dplayer-icons .dplayer-setting .dplayer-setting-danmaku .dplayer-danmaku-bar-wrap .dplayer-danmaku-bar .dplayer-danmaku-bar-inner .dplayer-thumb {\n                  position: absolute;\n                  top: 0;\n                  right: 5px;\n                  margin-top: -4px;\n                  margin-right: -10px;\n                  height: 11px;\n                  width: 11px;\n                  border-radius: 50%;\n                  cursor: pointer !important;\n                  -webkit-transition: all .3s ease-in-out;\n                  transition: all .3s ease-in-out;\n                  background: #aaa; }\n      .dplayer .dplayer-controller .dplayer-icons .dplayer-comment {\n        display: inline-block;\n        height: 100%; }\n        .dplayer .dplayer-controller .dplayer-icons .dplayer-comment .dplayer-comment-box {\n          position: absolute;\n          right: 0;\n          bottom: 50px;\n          -webkit-transform: translateX(382px);\n                  transform: translateX(382px);\n          border-radius: 2px;\n          -webkit-transition: all .3s ease-in-out;\n          transition: all .3s ease-in-out;\n          z-index: 2; }\n          .dplayer .dplayer-controller .dplayer-icons .dplayer-comment .dplayer-comment-box.dplayer-comment-box-open {\n            -webkit-transform: translateX(0);\n                    transform: translateX(0); }\n          .dplayer .dplayer-controller .dplayer-icons .dplayer-comment .dplayer-comment-box .dplayer-comment-setting-icon {\n            height: 24px;\n            width: 24px;\n            position: absolute;\n            top: 5px;\n            left: 7px;\n            padding: 0;\n            opacity: 1; }\n            .dplayer .dplayer-controller .dplayer-icons .dplayer-comment .dplayer-comment-box .dplayer-comment-setting-icon:hover .dplayer-fill {\n              fill: #aaa; }\n            .dplayer .dplayer-controller .dplayer-icons .dplayer-comment .dplayer-comment-box .dplayer-comment-setting-icon .dplayer-fill {\n              -webkit-transition: all .2s ease-in-out;\n              transition: all .2s ease-in-out;\n              fill: #ddd; }\n          .dplayer .dplayer-controller .dplayer-icons .dplayer-comment .dplayer-comment-box .dplayer-comment-setting-box {\n            position: absolute;\n            background: #fff;\n            bottom: 40px;\n            left: -93px;\n            box-shadow: 0 0 25px rgba(0, 0, 0, 0.3);\n            border-radius: 4px;\n            padding: 10px 10px 16px;\n            font-size: 14px;\n            width: 204px;\n            -webkit-transition: all .3s ease-in-out;\n            transition: all .3s ease-in-out;\n            -webkit-transform: scale(0);\n                    transform: scale(0); }\n            .dplayer .dplayer-controller .dplayer-icons .dplayer-comment .dplayer-comment-box .dplayer-comment-setting-box.dplayer-comment-setting-open {\n              -webkit-transform: scale(1);\n                      transform: scale(1); }\n            .dplayer .dplayer-controller .dplayer-icons .dplayer-comment .dplayer-comment-box .dplayer-comment-setting-box::after {\n              content: '';\n              position: absolute;\n              top: 100%;\n              left: 50%;\n              margin-left: -12px;\n              background: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 12\"><path fill=\"#FFF\" d=\"M23.7,0c-1.2,0-2.4,0.5-3.2,1.3l-7.7,7.8c-0.4,0.4-1.1,0.4-1.5,0L3.5,1.3C2.7,0.5,1.5,0,0.3,0\"/></svg>');\n              width: 24px;\n              height: 12px; }\n            .dplayer .dplayer-controller .dplayer-icons .dplayer-comment .dplayer-comment-box .dplayer-comment-setting-box input[type=radio] {\n              display: none; }\n            .dplayer .dplayer-controller .dplayer-icons .dplayer-comment .dplayer-comment-box .dplayer-comment-setting-box label {\n              cursor: pointer; }\n            .dplayer .dplayer-controller .dplayer-icons .dplayer-comment .dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-title {\n              font-size: 14px;\n              color: #555;\n              padding: 6px; }\n            .dplayer .dplayer-controller .dplayer-icons .dplayer-comment .dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-type {\n              font-size: 0; }\n              .dplayer .dplayer-controller .dplayer-icons .dplayer-comment .dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-type label:nth-child(2) span {\n                border-radius: 4px 0 0 4px; }\n              .dplayer .dplayer-controller .dplayer-icons .dplayer-comment .dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-type label:nth-child(4) span {\n                border-radius: 0 4px 4px 0; }\n              .dplayer .dplayer-controller .dplayer-icons .dplayer-comment .dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-type span {\n                width: 33%;\n                padding: 4px 6px;\n                line-height: 16px;\n                display: inline-block;\n                font-size: 12px;\n                color: #555;\n                border: 1px solid #E4E4E6;\n                margin-right: -1px;\n                box-sizing: border-box;\n                text-align: center;\n                cursor: pointer; }\n              .dplayer .dplayer-controller .dplayer-icons .dplayer-comment .dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-type input:checked + span {\n                background: #E4E4E6; }\n            .dplayer .dplayer-controller .dplayer-icons .dplayer-comment .dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-color {\n              font-size: 0; }\n              .dplayer .dplayer-controller .dplayer-icons .dplayer-comment .dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-color label {\n                font-size: 0;\n                padding: 6px;\n                display: inline-block; }\n              .dplayer .dplayer-controller .dplayer-icons .dplayer-comment .dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-color span {\n                width: 22px;\n                height: 22px;\n                display: inline-block;\n                border-radius: 50%;\n                box-sizing: border-box;\n                cursor: pointer; }\n                .dplayer .dplayer-controller .dplayer-icons .dplayer-comment .dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-color span:hover {\n                  -webkit-animation: my-face 5s infinite ease-in-out;\n                          animation: my-face 5s infinite ease-in-out;\n                  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12); }\n              .dplayer .dplayer-controller .dplayer-icons .dplayer-comment .dplayer-comment-box .dplayer-comment-setting-box .dplayer-comment-setting-color input:checked + span {\n                box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n                border: none !important; }\n          .dplayer .dplayer-controller .dplayer-icons .dplayer-comment .dplayer-comment-box .dplayer-comment-input {\n            outline: none;\n            border: none;\n            padding: 8px 31px;\n            font-size: 14px;\n            line-height: 18px;\n            text-align: center;\n            border-radius: 4px;\n            width: 300px;\n            background: #fff;\n            margin: 0;\n            height: auto; }\n          .dplayer .dplayer-controller .dplayer-icons .dplayer-comment .dplayer-comment-box .dplayer-send-icon {\n            height: 22px;\n            width: 22px;\n            position: absolute;\n            top: 6px;\n            right: 7px;\n            padding: 0;\n            opacity: 1; }\n            .dplayer .dplayer-controller .dplayer-icons .dplayer-comment .dplayer-comment-box .dplayer-send-icon:hover .dplayer-fill {\n              fill: #aaa; }\n            .dplayer .dplayer-controller .dplayer-icons .dplayer-comment .dplayer-comment-box .dplayer-send-icon .dplayer-fill {\n              -webkit-transition: all .2s ease-in-out;\n              transition: all .2s ease-in-out;\n              fill: #ddd; }\n      .dplayer .dplayer-controller .dplayer-icons .dplayer-label {\n        color: #eee;\n        font-size: 13px;\n        display: inline-block;\n        vertical-align: middle; }\n      .dplayer .dplayer-controller .dplayer-icons .dplayer-toggle {\n        width: 32px;\n        height: 100%;\n        text-align: center;\n        display: inline-block;\n        font-size: 0;\n        vertical-align: middle;\n        float: right; }\n        .dplayer .dplayer-controller .dplayer-icons .dplayer-toggle input {\n          max-height: 0;\n          max-width: 0;\n          display: none; }\n        .dplayer .dplayer-controller .dplayer-icons .dplayer-toggle input + label {\n          display: inline-block;\n          position: relative;\n          box-shadow: #dfdfdf 0 0 0 0 inset;\n          border: 1px solid #dfdfdf;\n          height: 20px;\n          width: 32px;\n          border-radius: 10px;\n          box-sizing: border-box;\n          cursor: pointer;\n          -webkit-transition: .2s ease-in-out;\n          transition: .2s ease-in-out; }\n        .dplayer .dplayer-controller .dplayer-icons .dplayer-toggle input + label:before {\n          content: \"\";\n          position: absolute;\n          display: block;\n          height: 18px;\n          width: 18px;\n          top: 0;\n          left: 0;\n          border-radius: 15px;\n          -webkit-transition: .2s ease-in-out;\n          transition: .2s ease-in-out; }\n        .dplayer .dplayer-controller .dplayer-icons .dplayer-toggle input + label:after {\n          content: \"\";\n          position: absolute;\n          display: block;\n          left: 0;\n          top: 0;\n          border-radius: 15px;\n          background: #fff;\n          -webkit-transition: .2s ease-in-out;\n          transition: .2s ease-in-out;\n          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);\n          height: 18px;\n          width: 18px; }\n        .dplayer .dplayer-controller .dplayer-icons .dplayer-toggle input:checked + label {\n          border-color: rgba(255, 255, 255, 0.5); }\n        .dplayer .dplayer-controller .dplayer-icons .dplayer-toggle input:checked + label:before {\n          width: 30px;\n          background: rgba(255, 255, 255, 0.5); }\n        .dplayer .dplayer-controller .dplayer-icons .dplayer-toggle input:checked + label:after {\n          left: 12px; }\n  .dplayer .dplayer-menu {\n    position: absolute;\n    width: 150px;\n    border-radius: 2px;\n    background: rgba(28, 28, 28, 0.9);\n    padding: 5px 0;\n    overflow: hidden;\n    z-index: 3;\n    display: none; }\n    .dplayer .dplayer-menu.dplayer-menu-show {\n      display: block; }\n    .dplayer .dplayer-menu .dplayer-menu-item {\n      height: 30px;\n      padding: 5px 10px;\n      box-sizing: border-box;\n      cursor: pointer; }\n      .dplayer .dplayer-menu .dplayer-menu-item:hover {\n        background-color: rgba(255, 255, 255, 0.1); }\n      .dplayer .dplayer-menu .dplayer-menu-item .dplayer-menu-label a {\n        color: #eee;\n        font-size: 13px;\n        display: inline-block;\n        vertical-align: middle; }\n\n@-webkit-keyframes my-face {\n  2% {\n    -webkit-transform: translate(0, 1.5px) rotate(1.5deg);\n            transform: translate(0, 1.5px) rotate(1.5deg); }\n  4% {\n    -webkit-transform: translate(0, -1.5px) rotate(-0.5deg);\n            transform: translate(0, -1.5px) rotate(-0.5deg); }\n  6% {\n    -webkit-transform: translate(0, 1.5px) rotate(-1.5deg);\n            transform: translate(0, 1.5px) rotate(-1.5deg); }\n  8% {\n    -webkit-transform: translate(0, -1.5px) rotate(-1.5deg);\n            transform: translate(0, -1.5px) rotate(-1.5deg); }\n  10% {\n    -webkit-transform: translate(0, 2.5px) rotate(1.5deg);\n            transform: translate(0, 2.5px) rotate(1.5deg); }\n  12% {\n    -webkit-transform: translate(0, -0.5px) rotate(1.5deg);\n            transform: translate(0, -0.5px) rotate(1.5deg); }\n  14% {\n    -webkit-transform: translate(0, -1.5px) rotate(1.5deg);\n            transform: translate(0, -1.5px) rotate(1.5deg); }\n  16% {\n    -webkit-transform: translate(0, -0.5px) rotate(-1.5deg);\n            transform: translate(0, -0.5px) rotate(-1.5deg); }\n  18% {\n    -webkit-transform: translate(0, 0.5px) rotate(-1.5deg);\n            transform: translate(0, 0.5px) rotate(-1.5deg); }\n  20% {\n    -webkit-transform: translate(0, -1.5px) rotate(2.5deg);\n            transform: translate(0, -1.5px) rotate(2.5deg); }\n  22% {\n    -webkit-transform: translate(0, 0.5px) rotate(-1.5deg);\n            transform: translate(0, 0.5px) rotate(-1.5deg); }\n  24% {\n    -webkit-transform: translate(0, 1.5px) rotate(1.5deg);\n            transform: translate(0, 1.5px) rotate(1.5deg); }\n  26% {\n    -webkit-transform: translate(0, 0.5px) rotate(0.5deg);\n            transform: translate(0, 0.5px) rotate(0.5deg); }\n  28% {\n    -webkit-transform: translate(0, 0.5px) rotate(1.5deg);\n            transform: translate(0, 0.5px) rotate(1.5deg); }\n  30% {\n    -webkit-transform: translate(0, -0.5px) rotate(2.5deg);\n            transform: translate(0, -0.5px) rotate(2.5deg); }\n  32% {\n    -webkit-transform: translate(0, 1.5px) rotate(-0.5deg);\n            transform: translate(0, 1.5px) rotate(-0.5deg); }\n  34% {\n    -webkit-transform: translate(0, 1.5px) rotate(-0.5deg);\n            transform: translate(0, 1.5px) rotate(-0.5deg); }\n  36% {\n    -webkit-transform: translate(0, -1.5px) rotate(2.5deg);\n            transform: translate(0, -1.5px) rotate(2.5deg); }\n  38% {\n    -webkit-transform: translate(0, 1.5px) rotate(-1.5deg);\n            transform: translate(0, 1.5px) rotate(-1.5deg); }\n  40% {\n    -webkit-transform: translate(0, -0.5px) rotate(2.5deg);\n            transform: translate(0, -0.5px) rotate(2.5deg); }\n  42% {\n    -webkit-transform: translate(0, 2.5px) rotate(-1.5deg);\n            transform: translate(0, 2.5px) rotate(-1.5deg); }\n  44% {\n    -webkit-transform: translate(0, 1.5px) rotate(0.5deg);\n            transform: translate(0, 1.5px) rotate(0.5deg); }\n  46% {\n    -webkit-transform: translate(0, -1.5px) rotate(2.5deg);\n            transform: translate(0, -1.5px) rotate(2.5deg); }\n  48% {\n    -webkit-transform: translate(0, -0.5px) rotate(0.5deg);\n            transform: translate(0, -0.5px) rotate(0.5deg); }\n  50% {\n    -webkit-transform: translate(0, 0.5px) rotate(0.5deg);\n            transform: translate(0, 0.5px) rotate(0.5deg); }\n  52% {\n    -webkit-transform: translate(0, 2.5px) rotate(2.5deg);\n            transform: translate(0, 2.5px) rotate(2.5deg); }\n  54% {\n    -webkit-transform: translate(0, -1.5px) rotate(1.5deg);\n            transform: translate(0, -1.5px) rotate(1.5deg); }\n  56% {\n    -webkit-transform: translate(0, 2.5px) rotate(2.5deg);\n            transform: translate(0, 2.5px) rotate(2.5deg); }\n  58% {\n    -webkit-transform: translate(0, 0.5px) rotate(2.5deg);\n            transform: translate(0, 0.5px) rotate(2.5deg); }\n  60% {\n    -webkit-transform: translate(0, 2.5px) rotate(2.5deg);\n            transform: translate(0, 2.5px) rotate(2.5deg); }\n  62% {\n    -webkit-transform: translate(0, -0.5px) rotate(2.5deg);\n            transform: translate(0, -0.5px) rotate(2.5deg); }\n  64% {\n    -webkit-transform: translate(0, -0.5px) rotate(1.5deg);\n            transform: translate(0, -0.5px) rotate(1.5deg); }\n  66% {\n    -webkit-transform: translate(0, 1.5px) rotate(-0.5deg);\n            transform: translate(0, 1.5px) rotate(-0.5deg); }\n  68% {\n    -webkit-transform: translate(0, -1.5px) rotate(-0.5deg);\n            transform: translate(0, -1.5px) rotate(-0.5deg); }\n  70% {\n    -webkit-transform: translate(0, 1.5px) rotate(0.5deg);\n            transform: translate(0, 1.5px) rotate(0.5deg); }\n  72% {\n    -webkit-transform: translate(0, 2.5px) rotate(1.5deg);\n            transform: translate(0, 2.5px) rotate(1.5deg); }\n  74% {\n    -webkit-transform: translate(0, -0.5px) rotate(0.5deg);\n            transform: translate(0, -0.5px) rotate(0.5deg); }\n  76% {\n    -webkit-transform: translate(0, -0.5px) rotate(2.5deg);\n            transform: translate(0, -0.5px) rotate(2.5deg); }\n  78% {\n    -webkit-transform: translate(0, -0.5px) rotate(1.5deg);\n            transform: translate(0, -0.5px) rotate(1.5deg); }\n  80% {\n    -webkit-transform: translate(0, 1.5px) rotate(1.5deg);\n            transform: translate(0, 1.5px) rotate(1.5deg); }\n  82% {\n    -webkit-transform: translate(0, -0.5px) rotate(0.5deg);\n            transform: translate(0, -0.5px) rotate(0.5deg); }\n  84% {\n    -webkit-transform: translate(0, 1.5px) rotate(2.5deg);\n            transform: translate(0, 1.5px) rotate(2.5deg); }\n  86% {\n    -webkit-transform: translate(0, -1.5px) rotate(-1.5deg);\n            transform: translate(0, -1.5px) rotate(-1.5deg); }\n  88% {\n    -webkit-transform: translate(0, -0.5px) rotate(2.5deg);\n            transform: translate(0, -0.5px) rotate(2.5deg); }\n  90% {\n    -webkit-transform: translate(0, 2.5px) rotate(-0.5deg);\n            transform: translate(0, 2.5px) rotate(-0.5deg); }\n  92% {\n    -webkit-transform: translate(0, 0.5px) rotate(-0.5deg);\n            transform: translate(0, 0.5px) rotate(-0.5deg); }\n  94% {\n    -webkit-transform: translate(0, 2.5px) rotate(0.5deg);\n            transform: translate(0, 2.5px) rotate(0.5deg); }\n  96% {\n    -webkit-transform: translate(0, -0.5px) rotate(1.5deg);\n            transform: translate(0, -0.5px) rotate(1.5deg); }\n  98% {\n    -webkit-transform: translate(0, -1.5px) rotate(-0.5deg);\n            transform: translate(0, -1.5px) rotate(-0.5deg); }\n  0%, 100% {\n    -webkit-transform: translate(0, 0) rotate(0deg);\n            transform: translate(0, 0) rotate(0deg); } }\n\n@keyframes my-face {\n  2% {\n    -webkit-transform: translate(0, 1.5px) rotate(1.5deg);\n            transform: translate(0, 1.5px) rotate(1.5deg); }\n  4% {\n    -webkit-transform: translate(0, -1.5px) rotate(-0.5deg);\n            transform: translate(0, -1.5px) rotate(-0.5deg); }\n  6% {\n    -webkit-transform: translate(0, 1.5px) rotate(-1.5deg);\n            transform: translate(0, 1.5px) rotate(-1.5deg); }\n  8% {\n    -webkit-transform: translate(0, -1.5px) rotate(-1.5deg);\n            transform: translate(0, -1.5px) rotate(-1.5deg); }\n  10% {\n    -webkit-transform: translate(0, 2.5px) rotate(1.5deg);\n            transform: translate(0, 2.5px) rotate(1.5deg); }\n  12% {\n    -webkit-transform: translate(0, -0.5px) rotate(1.5deg);\n            transform: translate(0, -0.5px) rotate(1.5deg); }\n  14% {\n    -webkit-transform: translate(0, -1.5px) rotate(1.5deg);\n            transform: translate(0, -1.5px) rotate(1.5deg); }\n  16% {\n    -webkit-transform: translate(0, -0.5px) rotate(-1.5deg);\n            transform: translate(0, -0.5px) rotate(-1.5deg); }\n  18% {\n    -webkit-transform: translate(0, 0.5px) rotate(-1.5deg);\n            transform: translate(0, 0.5px) rotate(-1.5deg); }\n  20% {\n    -webkit-transform: translate(0, -1.5px) rotate(2.5deg);\n            transform: translate(0, -1.5px) rotate(2.5deg); }\n  22% {\n    -webkit-transform: translate(0, 0.5px) rotate(-1.5deg);\n            transform: translate(0, 0.5px) rotate(-1.5deg); }\n  24% {\n    -webkit-transform: translate(0, 1.5px) rotate(1.5deg);\n            transform: translate(0, 1.5px) rotate(1.5deg); }\n  26% {\n    -webkit-transform: translate(0, 0.5px) rotate(0.5deg);\n            transform: translate(0, 0.5px) rotate(0.5deg); }\n  28% {\n    -webkit-transform: translate(0, 0.5px) rotate(1.5deg);\n            transform: translate(0, 0.5px) rotate(1.5deg); }\n  30% {\n    -webkit-transform: translate(0, -0.5px) rotate(2.5deg);\n            transform: translate(0, -0.5px) rotate(2.5deg); }\n  32% {\n    -webkit-transform: translate(0, 1.5px) rotate(-0.5deg);\n            transform: translate(0, 1.5px) rotate(-0.5deg); }\n  34% {\n    -webkit-transform: translate(0, 1.5px) rotate(-0.5deg);\n            transform: translate(0, 1.5px) rotate(-0.5deg); }\n  36% {\n    -webkit-transform: translate(0, -1.5px) rotate(2.5deg);\n            transform: translate(0, -1.5px) rotate(2.5deg); }\n  38% {\n    -webkit-transform: translate(0, 1.5px) rotate(-1.5deg);\n            transform: translate(0, 1.5px) rotate(-1.5deg); }\n  40% {\n    -webkit-transform: translate(0, -0.5px) rotate(2.5deg);\n            transform: translate(0, -0.5px) rotate(2.5deg); }\n  42% {\n    -webkit-transform: translate(0, 2.5px) rotate(-1.5deg);\n            transform: translate(0, 2.5px) rotate(-1.5deg); }\n  44% {\n    -webkit-transform: translate(0, 1.5px) rotate(0.5deg);\n            transform: translate(0, 1.5px) rotate(0.5deg); }\n  46% {\n    -webkit-transform: translate(0, -1.5px) rotate(2.5deg);\n            transform: translate(0, -1.5px) rotate(2.5deg); }\n  48% {\n    -webkit-transform: translate(0, -0.5px) rotate(0.5deg);\n            transform: translate(0, -0.5px) rotate(0.5deg); }\n  50% {\n    -webkit-transform: translate(0, 0.5px) rotate(0.5deg);\n            transform: translate(0, 0.5px) rotate(0.5deg); }\n  52% {\n    -webkit-transform: translate(0, 2.5px) rotate(2.5deg);\n            transform: translate(0, 2.5px) rotate(2.5deg); }\n  54% {\n    -webkit-transform: translate(0, -1.5px) rotate(1.5deg);\n            transform: translate(0, -1.5px) rotate(1.5deg); }\n  56% {\n    -webkit-transform: translate(0, 2.5px) rotate(2.5deg);\n            transform: translate(0, 2.5px) rotate(2.5deg); }\n  58% {\n    -webkit-transform: translate(0, 0.5px) rotate(2.5deg);\n            transform: translate(0, 0.5px) rotate(2.5deg); }\n  60% {\n    -webkit-transform: translate(0, 2.5px) rotate(2.5deg);\n            transform: translate(0, 2.5px) rotate(2.5deg); }\n  62% {\n    -webkit-transform: translate(0, -0.5px) rotate(2.5deg);\n            transform: translate(0, -0.5px) rotate(2.5deg); }\n  64% {\n    -webkit-transform: translate(0, -0.5px) rotate(1.5deg);\n            transform: translate(0, -0.5px) rotate(1.5deg); }\n  66% {\n    -webkit-transform: translate(0, 1.5px) rotate(-0.5deg);\n            transform: translate(0, 1.5px) rotate(-0.5deg); }\n  68% {\n    -webkit-transform: translate(0, -1.5px) rotate(-0.5deg);\n            transform: translate(0, -1.5px) rotate(-0.5deg); }\n  70% {\n    -webkit-transform: translate(0, 1.5px) rotate(0.5deg);\n            transform: translate(0, 1.5px) rotate(0.5deg); }\n  72% {\n    -webkit-transform: translate(0, 2.5px) rotate(1.5deg);\n            transform: translate(0, 2.5px) rotate(1.5deg); }\n  74% {\n    -webkit-transform: translate(0, -0.5px) rotate(0.5deg);\n            transform: translate(0, -0.5px) rotate(0.5deg); }\n  76% {\n    -webkit-transform: translate(0, -0.5px) rotate(2.5deg);\n            transform: translate(0, -0.5px) rotate(2.5deg); }\n  78% {\n    -webkit-transform: translate(0, -0.5px) rotate(1.5deg);\n            transform: translate(0, -0.5px) rotate(1.5deg); }\n  80% {\n    -webkit-transform: translate(0, 1.5px) rotate(1.5deg);\n            transform: translate(0, 1.5px) rotate(1.5deg); }\n  82% {\n    -webkit-transform: translate(0, -0.5px) rotate(0.5deg);\n            transform: translate(0, -0.5px) rotate(0.5deg); }\n  84% {\n    -webkit-transform: translate(0, 1.5px) rotate(2.5deg);\n            transform: translate(0, 1.5px) rotate(2.5deg); }\n  86% {\n    -webkit-transform: translate(0, -1.5px) rotate(-1.5deg);\n            transform: translate(0, -1.5px) rotate(-1.5deg); }\n  88% {\n    -webkit-transform: translate(0, -0.5px) rotate(2.5deg);\n            transform: translate(0, -0.5px) rotate(2.5deg); }\n  90% {\n    -webkit-transform: translate(0, 2.5px) rotate(-0.5deg);\n            transform: translate(0, 2.5px) rotate(-0.5deg); }\n  92% {\n    -webkit-transform: translate(0, 0.5px) rotate(-0.5deg);\n            transform: translate(0, 0.5px) rotate(-0.5deg); }\n  94% {\n    -webkit-transform: translate(0, 2.5px) rotate(0.5deg);\n            transform: translate(0, 2.5px) rotate(0.5deg); }\n  96% {\n    -webkit-transform: translate(0, -0.5px) rotate(1.5deg);\n            transform: translate(0, -0.5px) rotate(1.5deg); }\n  98% {\n    -webkit-transform: translate(0, -1.5px) rotate(-0.5deg);\n            transform: translate(0, -1.5px) rotate(-0.5deg); }\n  0%, 100% {\n    -webkit-transform: translate(0, 0) rotate(0deg);\n            transform: translate(0, 0) rotate(0deg); } }\n", ""]);

// exports


/***/ }),
/* 3 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 4 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [];

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	styleElement.type = "text/css";
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	linkElement.rel = "stylesheet";
	insertStyleElement(options, linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

console.log("\n %c DPlayer 1.1.3 %c http://dplayer.js.org \n\n", "color: #fadfa3; background: #030307; padding:5px 0;", "background: #fadfa3; padding:5px 0;");

__webpack_require__(1);
var defaultApiBackend = __webpack_require__(0);

var index = 0;

var DPlayer = function () {
    /**
     * DPlayer constructor function
     *
     * @param {Object} option - See README
     * @constructor
     */
    function DPlayer(option) {
        var _this = this;

        _classCallCheck(this, DPlayer);

        var svg = {
            'play': ['0 0 16 32', 'M15.552 15.168q0.448 0.32 0.448 0.832 0 0.448-0.448 0.768l-13.696 8.512q-0.768 0.512-1.312 0.192t-0.544-1.28v-16.448q0-0.96 0.544-1.28t1.312 0.192z'],
            'pause': ['0 0 17 32', 'M14.080 4.8q2.88 0 2.88 2.048v18.24q0 2.112-2.88 2.112t-2.88-2.112v-18.24q0-2.048 2.88-2.048zM2.88 4.8q2.88 0 2.88 2.048v18.24q0 2.112-2.88 2.112t-2.88-2.112v-18.24q0-2.048 2.88-2.048z'],
            'volume-up': ['0 0 21 32', 'M13.728 6.272v19.456q0 0.448-0.352 0.8t-0.8 0.32-0.8-0.32l-5.952-5.952h-4.672q-0.48 0-0.8-0.352t-0.352-0.8v-6.848q0-0.48 0.352-0.8t0.8-0.352h4.672l5.952-5.952q0.32-0.32 0.8-0.32t0.8 0.32 0.352 0.8zM20.576 16q0 1.344-0.768 2.528t-2.016 1.664q-0.16 0.096-0.448 0.096-0.448 0-0.8-0.32t-0.32-0.832q0-0.384 0.192-0.64t0.544-0.448 0.608-0.384 0.512-0.64 0.192-1.024-0.192-1.024-0.512-0.64-0.608-0.384-0.544-0.448-0.192-0.64q0-0.48 0.32-0.832t0.8-0.32q0.288 0 0.448 0.096 1.248 0.48 2.016 1.664t0.768 2.528zM25.152 16q0 2.72-1.536 5.056t-4 3.36q-0.256 0.096-0.448 0.096-0.48 0-0.832-0.352t-0.32-0.8q0-0.704 0.672-1.056 1.024-0.512 1.376-0.8 1.312-0.96 2.048-2.4t0.736-3.104-0.736-3.104-2.048-2.4q-0.352-0.288-1.376-0.8-0.672-0.352-0.672-1.056 0-0.448 0.32-0.8t0.8-0.352q0.224 0 0.48 0.096 2.496 1.056 4 3.36t1.536 5.056zM29.728 16q0 4.096-2.272 7.552t-6.048 5.056q-0.224 0.096-0.448 0.096-0.48 0-0.832-0.352t-0.32-0.8q0-0.64 0.704-1.056 0.128-0.064 0.384-0.192t0.416-0.192q0.8-0.448 1.44-0.896 2.208-1.632 3.456-4.064t1.216-5.152-1.216-5.152-3.456-4.064q-0.64-0.448-1.44-0.896-0.128-0.096-0.416-0.192t-0.384-0.192q-0.704-0.416-0.704-1.056 0-0.448 0.32-0.8t0.832-0.352q0.224 0 0.448 0.096 3.776 1.632 6.048 5.056t2.272 7.552z'],
            'volume-down': ['0 0 21 32', 'M13.728 6.272v19.456q0 0.448-0.352 0.8t-0.8 0.32-0.8-0.32l-5.952-5.952h-4.672q-0.48 0-0.8-0.352t-0.352-0.8v-6.848q0-0.48 0.352-0.8t0.8-0.352h4.672l5.952-5.952q0.32-0.32 0.8-0.32t0.8 0.32 0.352 0.8zM20.576 16q0 1.344-0.768 2.528t-2.016 1.664q-0.16 0.096-0.448 0.096-0.448 0-0.8-0.32t-0.32-0.832q0-0.384 0.192-0.64t0.544-0.448 0.608-0.384 0.512-0.64 0.192-1.024-0.192-1.024-0.512-0.64-0.608-0.384-0.544-0.448-0.192-0.64q0-0.48 0.32-0.832t0.8-0.32q0.288 0 0.448 0.096 1.248 0.48 2.016 1.664t0.768 2.528z'],
            'volume-off': ['0 0 21 32', 'M13.728 6.272v19.456q0 0.448-0.352 0.8t-0.8 0.32-0.8-0.32l-5.952-5.952h-4.672q-0.48 0-0.8-0.352t-0.352-0.8v-6.848q0-0.48 0.352-0.8t0.8-0.352h4.672l5.952-5.952q0.32-0.32 0.8-0.32t0.8 0.32 0.352 0.8z'],
            'loop': ['0 0 32 32', 'M1.882 16.941c0 4.152 3.221 7.529 7.177 7.529v1.882c-4.996 0-9.060-4.222-9.060-9.412s4.064-9.412 9.060-9.412h7.96l-3.098-3.098 1.331-1.331 5.372 5.37-5.37 5.372-1.333-1.333 3.1-3.098h-7.962c-3.957 0-7.177 3.377-7.177 7.529zM22.94 7.529v1.882c3.957 0 7.177 3.377 7.177 7.529s-3.221 7.529-7.177 7.529h-7.962l3.098-3.098-1.331-1.331-5.37 5.37 5.372 5.372 1.331-1.331-3.1-3.1h7.96c4.998 0 9.062-4.222 9.062-9.412s-4.064-9.412-9.060-9.412z'],
            'full': ['0 0 32 33', 'M6.667 28h-5.333c-0.8 0-1.333-0.533-1.333-1.333v-5.333c0-0.8 0.533-1.333 1.333-1.333s1.333 0.533 1.333 1.333v4h4c0.8 0 1.333 0.533 1.333 1.333s-0.533 1.333-1.333 1.333zM30.667 28h-5.333c-0.8 0-1.333-0.533-1.333-1.333s0.533-1.333 1.333-1.333h4v-4c0-0.8 0.533-1.333 1.333-1.333s1.333 0.533 1.333 1.333v5.333c0 0.8-0.533 1.333-1.333 1.333zM30.667 12c-0.8 0-1.333-0.533-1.333-1.333v-4h-4c-0.8 0-1.333-0.533-1.333-1.333s0.533-1.333 1.333-1.333h5.333c0.8 0 1.333 0.533 1.333 1.333v5.333c0 0.8-0.533 1.333-1.333 1.333zM1.333 12c-0.8 0-1.333-0.533-1.333-1.333v-5.333c0-0.8 0.533-1.333 1.333-1.333h5.333c0.8 0 1.333 0.533 1.333 1.333s-0.533 1.333-1.333 1.333h-4v4c0 0.8-0.533 1.333-1.333 1.333z'],
            'setting': ['0 0 32 28', 'M28.633 17.104c0.035 0.21 0.026 0.463-0.026 0.76s-0.14 0.598-0.262 0.904c-0.122 0.306-0.271 0.581-0.445 0.825s-0.367 0.419-0.576 0.524c-0.209 0.105-0.393 0.157-0.55 0.157s-0.332-0.035-0.524-0.105c-0.175-0.052-0.393-0.1-0.655-0.144s-0.528-0.052-0.799-0.026c-0.271 0.026-0.541 0.083-0.812 0.17s-0.502 0.236-0.694 0.445c-0.419 0.437-0.664 0.934-0.734 1.493s0.009 1.092 0.236 1.598c0.175 0.349 0.148 0.699-0.079 1.048-0.105 0.14-0.271 0.284-0.498 0.432s-0.476 0.284-0.747 0.406-0.555 0.218-0.851 0.288c-0.297 0.070-0.559 0.105-0.786 0.105-0.157 0-0.306-0.061-0.445-0.183s-0.236-0.253-0.288-0.393h-0.026c-0.192-0.541-0.52-1.009-0.982-1.402s-1-0.589-1.611-0.589c-0.594 0-1.131 0.197-1.611 0.589s-0.816 0.851-1.009 1.375c-0.087 0.21-0.218 0.362-0.393 0.458s-0.367 0.144-0.576 0.144c-0.244 0-0.52-0.044-0.825-0.131s-0.611-0.197-0.917-0.327c-0.306-0.131-0.581-0.284-0.825-0.458s-0.428-0.349-0.55-0.524c-0.087-0.122-0.135-0.266-0.144-0.432s0.057-0.397 0.197-0.694c0.192-0.402 0.266-0.86 0.223-1.375s-0.266-0.991-0.668-1.428c-0.244-0.262-0.541-0.432-0.891-0.511s-0.681-0.109-0.995-0.092c-0.367 0.017-0.742 0.087-1.127 0.21-0.244 0.070-0.489 0.052-0.734-0.052-0.192-0.070-0.371-0.231-0.537-0.485s-0.314-0.533-0.445-0.838c-0.131-0.306-0.231-0.62-0.301-0.943s-0.087-0.59-0.052-0.799c0.052-0.384 0.227-0.629 0.524-0.734 0.524-0.21 0.995-0.555 1.415-1.035s0.629-1.017 0.629-1.611c0-0.611-0.21-1.144-0.629-1.598s-0.891-0.786-1.415-0.996c-0.157-0.052-0.288-0.179-0.393-0.38s-0.157-0.406-0.157-0.616c0-0.227 0.035-0.48 0.105-0.76s0.162-0.55 0.275-0.812 0.244-0.502 0.393-0.72c0.148-0.218 0.31-0.38 0.485-0.485 0.14-0.087 0.275-0.122 0.406-0.105s0.275 0.052 0.432 0.105c0.524 0.21 1.070 0.275 1.637 0.197s1.070-0.327 1.506-0.747c0.21-0.209 0.362-0.467 0.458-0.773s0.157-0.607 0.183-0.904c0.026-0.297 0.026-0.568 0-0.812s-0.048-0.419-0.065-0.524c-0.035-0.105-0.066-0.227-0.092-0.367s-0.013-0.262 0.039-0.367c0.105-0.244 0.293-0.458 0.563-0.642s0.563-0.336 0.878-0.458c0.314-0.122 0.62-0.214 0.917-0.275s0.533-0.092 0.707-0.092c0.227 0 0.406 0.074 0.537 0.223s0.223 0.301 0.275 0.458c0.192 0.471 0.507 0.886 0.943 1.244s0.952 0.537 1.546 0.537c0.611 0 1.153-0.17 1.624-0.511s0.803-0.773 0.996-1.297c0.070-0.14 0.179-0.284 0.327-0.432s0.301-0.223 0.458-0.223c0.244 0 0.511 0.035 0.799 0.105s0.572 0.166 0.851 0.288c0.279 0.122 0.537 0.279 0.773 0.472s0.423 0.402 0.563 0.629c0.087 0.14 0.113 0.293 0.079 0.458s-0.070 0.284-0.105 0.354c-0.227 0.506-0.297 1.039-0.21 1.598s0.341 1.048 0.76 1.467c0.419 0.419 0.934 0.651 1.546 0.694s1.179-0.057 1.703-0.301c0.14-0.087 0.31-0.122 0.511-0.105s0.371 0.096 0.511 0.236c0.262 0.244 0.493 0.616 0.694 1.113s0.336 1 0.406 1.506c0.035 0.297-0.013 0.528-0.144 0.694s-0.266 0.275-0.406 0.327c-0.542 0.192-1.004 0.528-1.388 1.009s-0.576 1.026-0.576 1.637c0 0.594 0.162 1.113 0.485 1.559s0.747 0.764 1.27 0.956c0.122 0.070 0.227 0.14 0.314 0.21 0.192 0.157 0.323 0.358 0.393 0.602v0zM16.451 19.462c0.786 0 1.528-0.149 2.227-0.445s1.305-0.707 1.821-1.231c0.515-0.524 0.921-1.131 1.218-1.821s0.445-1.428 0.445-2.214c0-0.786-0.148-1.524-0.445-2.214s-0.703-1.292-1.218-1.808c-0.515-0.515-1.122-0.921-1.821-1.218s-1.441-0.445-2.227-0.445c-0.786 0-1.524 0.148-2.214 0.445s-1.292 0.703-1.808 1.218c-0.515 0.515-0.921 1.118-1.218 1.808s-0.445 1.428-0.445 2.214c0 0.786 0.149 1.524 0.445 2.214s0.703 1.297 1.218 1.821c0.515 0.524 1.118 0.934 1.808 1.231s1.428 0.445 2.214 0.445v0z'],
            'right': ['0 0 32 32', 'M22 16l-10.105-10.6-1.895 1.987 8.211 8.613-8.211 8.612 1.895 1.988 8.211-8.613z'],
            'comment': ['0 0 32 32', 'M27.128 0.38h-22.553c-2.336 0-4.229 1.825-4.229 4.076v16.273c0 2.251 1.893 4.076 4.229 4.076h4.229v-2.685h8.403l-8.784 8.072 1.566 1.44 7.429-6.827h9.71c2.335 0 4.229-1.825 4.229-4.076v-16.273c0-2.252-1.894-4.076-4.229-4.076zM28.538 19.403c0 1.5-1.262 2.717-2.819 2.717h-8.36l-0.076-0.070-0.076 0.070h-11.223c-1.557 0-2.819-1.217-2.819-2.717v-13.589c0-1.501 1.262-2.718 2.819-2.718h19.734c1.557 0 2.819-0.141 2.819 1.359v14.947zM9.206 10.557c-1.222 0-2.215 0.911-2.215 2.036s0.992 2.035 2.215 2.035c1.224 0 2.216-0.911 2.216-2.035s-0.992-2.036-2.216-2.036zM22.496 10.557c-1.224 0-2.215 0.911-2.215 2.036s0.991 2.035 2.215 2.035c1.224 0 2.215-0.911 2.215-2.035s-0.991-2.036-2.215-2.036zM15.852 10.557c-1.224 0-2.215 0.911-2.215 2.036s0.991 2.035 2.215 2.035c1.222 0 2.215-0.911 2.215-2.035s-0.992-2.036-2.215-2.036z'],
            'comment-off': ['0 0 32 32', 'M27.090 0.131h-22.731c-2.354 0-4.262 1.839-4.262 4.109v16.401c0 2.269 1.908 4.109 4.262 4.109h4.262v-2.706h8.469l-8.853 8.135 1.579 1.451 7.487-6.88h9.787c2.353 0 4.262-1.84 4.262-4.109v-16.401c0-2.27-1.909-4.109-4.262-4.109v0zM28.511 19.304c0 1.512-1.272 2.738-2.841 2.738h-8.425l-0.076-0.070-0.076 0.070h-11.311c-1.569 0-2.841-1.226-2.841-2.738v-13.696c0-1.513 1.272-2.739 2.841-2.739h19.889c1.569 0 2.841-0.142 2.841 1.37v15.064z'],
            'send': ['0 0 32 32', 'M13.725 30l3.9-5.325-3.9-1.125v6.45zM0 17.5l11.050 3.35 13.6-11.55-10.55 12.425 11.8 3.65 6.1-23.375-32 15.5z'],
            'menu': ['0 0 22 32', 'M20.8 14.4q0.704 0 1.152 0.48t0.448 1.12-0.48 1.12-1.12 0.48h-19.2q-0.64 0-1.12-0.48t-0.48-1.12 0.448-1.12 1.152-0.48h19.2zM1.6 11.2q-0.64 0-1.12-0.48t-0.48-1.12 0.448-1.12 1.152-0.48h19.2q0.704 0 1.152 0.48t0.448 1.12-0.48 1.12-1.12 0.48h-19.2zM20.8 20.8q0.704 0 1.152 0.48t0.448 1.12-0.48 1.12-1.12 0.48h-19.2q-0.64 0-1.12-0.48t-0.48-1.12 0.448-1.12 1.152-0.48h19.2z'],
            'camera': ['0 0 32 32', 'M16 23c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6zM16 13c-2.206 0-4 1.794-4 4s1.794 4 4 4c2.206 0 4-1.794 4-4s-1.794-4-4-4zM27 28h-22c-1.654 0-3-1.346-3-3v-16c0-1.654 1.346-3 3-3h3c0.552 0 1 0.448 1 1s-0.448 1-1 1h-3c-0.551 0-1 0.449-1 1v16c0 0.552 0.449 1 1 1h22c0.552 0 1-0.448 1-1v-16c0-0.551-0.448-1-1-1h-11c-0.552 0-1-0.448-1-1s0.448-1 1-1h11c1.654 0 3 1.346 3 3v16c0 1.654-1.346 3-3 3zM24 10.5c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5zM15 4c0 0.552-0.448 1-1 1h-4c-0.552 0-1-0.448-1-1v0c0-0.552 0.448-1 1-1h4c0.552 0 1 0.448 1 1v0z']
        };
        this.getSVG = function (type) {
            return "\n                <svg xmlns:xlink=\"http://www.w3.org/1999/xlink\" height=\"100%\" version=\"1.1\" viewBox=\"" + svg[type][0] + "\" width=\"100%\">\n                    <use xlink:href=\"#dplayer-" + type + "\"></use>\n                    <path class=\"dplayer-fill\" d=\"" + svg[type][1] + "\" id=\"dplayer-" + type + "\"></path>\n                </svg>\n            ";
        };

        this.option = option;

        var isMobile = /mobile/i.test(window.navigator.userAgent);
        // compatibility: some mobile browsers don't suppose autoplay
        if (isMobile) {
            this.option.autoplay = false;
        }

        // default options
        var defaultOption = {
            element: document.getElementsByClassName('dplayer')[0],
            autoplay: false,
            theme: '#b7daff',
            loop: false,
            lang: navigator.language.indexOf('zh') !== -1 ? 'zh' : 'en',
            screenshot: false,
            hotkey: true,
            preload: 'auto',
            apiBackend: defaultApiBackend
        };
        for (var defaultKey in defaultOption) {
            if (defaultOption.hasOwnProperty(defaultKey) && !this.option.hasOwnProperty(defaultKey)) {
                this.option[defaultKey] = defaultOption[defaultKey];
            }
        }

        var tranZH = {
            'Danmaku is loading': '弹幕加载中',
            'Top': '顶部',
            'Bottom': '底部',
            'Rolling': '滚动',
            'Input danmaku, hit Enter': '输入弹幕，回车发送',
            'About author': '关于作者',
            'DPlayer feedback': '播放器意见反馈',
            'About DPlayer': '关于 DPlay 播放器',
            'Loop': '洗脑循环',
            'Speed': '速度',
            'Opacity for danmaku': '弹幕透明度',
            'Normal': '正常',
            'Please input danmaku!': '要输入弹幕内容啊喂！',
            'Set danmaku color': '设置弹幕颜色',
            'Set danmaku type': '设置弹幕类型',
            'Danmaku': '弹幕'
        };
        var getTran = function getTran(text) {
            if (_this.option.lang === 'en') {
                return text;
            } else if (_this.option.lang === 'zh') {
                return tranZH[text];
            }
        };

        /**
         * Update progress bar, including loading progress bar and play progress bar
         *
         * @param {String} type - Point out which bar it is, should be played loaded or volume
         * @param {Number} percentage
         * @param {String} direction - Point out the direction of this bar, Should be height or width
         */
        this.updateBar = function (type, percentage, direction) {
            percentage = percentage > 0 ? percentage : 0;
            percentage = percentage < 1 ? percentage : 1;
            bar[type + 'Bar'].style[direction] = percentage * 100 + '%';
        };

        // define DPlayer events
        var eventTypes = ['play', 'pause', 'canplay', 'playing', 'ended', 'error'];
        this.event = {};
        for (var i = 0; i < eventTypes.length; i++) {
            this.event[eventTypes[i]] = [];
        }
        this.trigger = function (type) {
            for (var _i = 0; _i < _this.event[type].length; _i++) {
                _this.event[type][_i]();
            }
        };

        this.element = this.option.element;
        if (!this.option.danmaku) {
            this.element.classList.add('dplayer-no-danmaku');
        }

        this.element.innerHTML = "\n            <div class=\"dplayer-mask\"></div>\n            <div class=\"dplayer-video-wrap\">\n                <video class=\"dplayer-video\" " + (this.option.video.pic ? "poster=\"" + this.option.video.pic + "\"" : "") + " webkit-playsinline playsinline " + (this.option.screenshot ? "crossorigin=\"anonymous\"" : "") + " preload=\"" + this.option.preload + "\" src=\"" + this.option.video.url + "\"></video>\n                <div class=\"dplayer-danmaku\">\n                    <div class=\"dplayer-danmaku-item dplayer-danmaku-item--demo\"></div>\n                </div>\n                <div class=\"dplayer-bezel\">\n                    <span class=\"dplayer-bezel-icon\"></span>\n                    " + (this.option.danmaku ? "<span class=\"dplayer-danloading\">" + getTran('Danmaku is loading') + "</span>" : "") + "\n                    <span class=\"diplayer-loading-icon\">\n                        <svg height=\"100%\" version=\"1.1\" viewBox=\"0 0 22 22\" width=\"100%\">\n                            <svg x=\"7\" y=\"1\">\n                                <circle class=\"diplayer-loading-dot diplayer-loading-dot-0\" cx=\"4\" cy=\"4\" r=\"2\"></circle>\n                            </svg>\n                            <svg x=\"11\" y=\"3\">\n                                <circle class=\"diplayer-loading-dot diplayer-loading-dot-1\" cx=\"4\" cy=\"4\" r=\"2\"></circle>\n                            </svg>\n                            <svg x=\"13\" y=\"7\">\n                                <circle class=\"diplayer-loading-dot diplayer-loading-dot-2\" cx=\"4\" cy=\"4\" r=\"2\"></circle>\n                            </svg>\n                            <svg x=\"11\" y=\"11\">\n                                <circle class=\"diplayer-loading-dot diplayer-loading-dot-3\" cx=\"4\" cy=\"4\" r=\"2\"></circle>\n                            </svg>\n                            <svg x=\"7\" y=\"13\">\n                                <circle class=\"diplayer-loading-dot diplayer-loading-dot-4\" cx=\"4\" cy=\"4\" r=\"2\"></circle>\n                            </svg>\n                            <svg x=\"3\" y=\"11\">\n                                <circle class=\"diplayer-loading-dot diplayer-loading-dot-5\" cx=\"4\" cy=\"4\" r=\"2\"></circle>\n                            </svg>\n                            <svg x=\"1\" y=\"7\">\n                                <circle class=\"diplayer-loading-dot diplayer-loading-dot-6\" cx=\"4\" cy=\"4\" r=\"2\"></circle>\n                            </svg>\n                            <svg x=\"3\" y=\"3\">\n                                <circle class=\"diplayer-loading-dot diplayer-loading-dot-7\" cx=\"4\" cy=\"4\" r=\"2\"></circle>\n                            </svg>\n                        </svg>\n                    </span>\n                </div>\n            </div>\n            <div class=\"dplayer-controller-mask\"></div>\n            <div class=\"dplayer-controller\">\n                <div class=\"dplayer-icons dplayer-icons-left\">\n                    <button class=\"dplayer-icon dplayer-play-icon\">" + this.getSVG('play') + ("     </button>\n                    <div class=\"dplayer-volume\" " + (isMobile ? 'style="display: none;"' : '') + ">\n                        <button class=\"dplayer-icon dplayer-volume-icon\">") + this.getSVG('volume-down') + ("         </button>\n                        <div class=\"dplayer-volume-bar-wrap\">\n                            <div class=\"dplayer-volume-bar\">\n                                <div class=\"dplayer-volume-bar-inner\" style=\"width: 70%; background: " + this.option.theme + ";\">\n                                    <span class=\"dplayer-thumb\" style=\"background: " + this.option.theme + "\"></span>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <span class=\"dplayer-time\"><span class=\"dplayer-ptime\">0:00</span> / <span class=\"dplayer-dtime\">0:00</span></span>\n                </div>\n                <div class=\"dplayer-icons dplayer-icons-right\">\n                    " + (this.option.screenshot ? "\n                    <a href=\"#\" class=\"dplayer-icon dplayer-camera-icon\" " + (isMobile ? 'style="display: none;"' : '') + "dplayer-volume>" + this.getSVG('camera') + "     </a>\n                    " : "") + "\n                    <div class=\"dplayer-comment\">\n                        <button class=\"dplayer-icon dplayer-comment-icon\">") + this.getSVG('comment') + "         </button>\n                        <div class=\"dplayer-comment-box\">\n                            <button class=\"dplayer-icon dplayer-comment-setting-icon\">" + this.getSVG('menu') + ("             </button>\n                            <div class=\"dplayer-comment-setting-box\">\n                                <div class=\"dplayer-comment-setting-color\">\n                                   <div class=\"dplayer-comment-setting-title\">" + getTran('Set danmaku color') + "</div>\n                                    <label>\n                                        <input type=\"radio\" name=\"dplayer-danmaku-color-" + index + "\" value=\"#fff\" checked>\n                                        <span style=\"background: #fff; border: 1px solid rgba(0,0,0,.1);\"></span>\n                                    </label>\n                                    <label>\n                                        <input type=\"radio\" name=\"dplayer-danmaku-color-" + index + "\" value=\"#e54256\">\n                                        <span style=\"background: #e54256\"></span>\n                                    </label>\n                                    <label>\n                                        <input type=\"radio\" name=\"dplayer-danmaku-color-" + index + "\" value=\"#ffe133\">\n                                        <span style=\"background: #ffe133\"></span>\n                                    </label>\n                                    <label>\n                                        <input type=\"radio\" name=\"dplayer-danmaku-color-" + index + "\" value=\"#64DD17\">\n                                        <span style=\"background: #64DD17\"></span>\n                                    </label>\n                                    <label>\n                                        <input type=\"radio\" name=\"dplayer-danmaku-color-" + index + "\" value=\"#39ccff\">\n                                        <span style=\"background: #39ccff\"></span>\n                                    </label>\n                                    <label>\n                                        <input type=\"radio\" name=\"dplayer-danmaku-color-" + index + "\" value=\"#D500F9\">\n                                        <span style=\"background: #D500F9\"></span>\n                                    </label>\n                                </div>\n                                <div class=\"dplayer-comment-setting-type\">\n                                    <div class=\"dplayer-comment-setting-title\">" + getTran('Set danmaku type') + "</div>\n                                    <label>\n                                        <input type=\"radio\" name=\"dplayer-danmaku-type-" + index + "\" value=\"top\">\n                                        <span>" + getTran('Top') + "</span>\n                                    </label>\n                                    <label>\n                                        <input type=\"radio\" name=\"dplayer-danmaku-type-" + index + "\" value=\"right\" checked>\n                                        <span>" + getTran('Rolling') + "</span>\n                                    </label>\n                                    <label>\n                                        <input type=\"radio\" name=\"dplayer-danmaku-type-" + index + "\" value=\"bottom\">\n                                        <span>" + getTran('Bottom') + "</span>\n                                    </label>\n                                </div>\n                            </div>\n                            <input class=\"dplayer-comment-input\" type=\"text\" placeholder=\"" + getTran('Input danmaku, hit Enter') + "\" maxlength=\"30\">\n                            <button class=\"dplayer-icon dplayer-send-icon\">") + this.getSVG('send') + "             </button>\n                        </div>\n                    </div>\n                    <div class=\"dplayer-setting\">\n                        <button class=\"dplayer-icon dplayer-setting-icon\">" + this.getSVG('setting') + "         </button>\n                        <div class=\"dplayer-setting-box\"></div>\n                    </div>\n                    <button class=\"dplayer-icon dplayer-full-icon\">" + this.getSVG('full') + ("     </button>\n                </div>\n                <div class=\"dplayer-bar-wrap\">\n                    <div class=\"dplayer-bar\">\n                        <div class=\"dplayer-loaded\" style=\"width: 0;\"></div>\n                        <div class=\"dplayer-played\" style=\"width: 0; background: " + this.option.theme + "\">\n                            <span class=\"dplayer-thumb\" style=\"background: " + this.option.theme + "\"></span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"dplayer-menu\">\n                <div class=\"dplayer-menu-item\"><span class=\"dplayer-menu-label\"><a target=\"_blank\" href=\"http://diygod.me/\">" + getTran('About author') + "</a></span></div>\n                <div class=\"dplayer-menu-item\"><span class=\"dplayer-menu-label\"><a target=\"_blank\" href=\"https://github.com/DIYgod/DPlayer/issues\">" + getTran('DPlayer feedback') + "</a></span></div>\n                <div class=\"dplayer-menu-item\"><span class=\"dplayer-menu-label\"><a target=\"_blank\" href=\"https://github.com/DIYgod/DPlayer\">" + getTran('About DPlayer') + "</a></span></div>\n            </div>\n        ");

        // arrow style
        var arrow = this.element.offsetWidth <= 500;
        if (arrow) {
            var arrowStyle = document.createElement('style');
            arrowStyle.innerHTML = ".dplayer .dplayer-danmaku{font-size:18px}";
            document.head.appendChild(arrowStyle);
        }

        // get this video object
        this.video = this.element.getElementsByClassName('dplayer-video')[0];

        // Support HTTP Live Streaming
        if (/(m3u8\?|m3u8$)/i.exec(this.option.video.url) && Hls.isSupported()) {
            this.element.getElementsByClassName('dplayer-time')[0].style.display = 'none';
            var hls = new Hls();
            hls.attachMedia(this.video);
            hls.on(Hls.Events.MEDIA_ATTACHED, function () {
                hls.loadSource(_this.option.video.url);
                hls.on(Hls.Events.MANIFEST_PARSED, function (event, data) {
                    console.log("manifest loaded, found " + data.levels.length + " quality level");
                });
            });
        }

        // Support FLV
        if (/(flv\?|flv$)/i.exec(this.option.video.url) && flvjs.isSupported()) {
            var flvPlayer = flvjs.createPlayer({
                type: 'flv',
                url: this.option.video.url
            });
            flvPlayer.attachMediaElement(this.video);
            flvPlayer.load();
        }

        this.bezel = this.element.getElementsByClassName('dplayer-bezel-icon')[0];
        this.bezel.addEventListener('animationend', function () {
            _this.bezel.classList.remove('dplayer-bezel-transition');
        });

        // play and pause button
        this.playButton = this.element.getElementsByClassName('dplayer-play-icon')[0];
        this.paused = true;
        this.playButton.addEventListener('click', function () {
            _this.toggle();
        });

        var videoWrap = this.element.getElementsByClassName('dplayer-video-wrap')[0];
        var conMask = this.element.getElementsByClassName('dplayer-controller-mask')[0];
        if (!isMobile) {
            videoWrap.addEventListener('click', function () {
                _this.toggle();
            });
            conMask.addEventListener('click', function () {
                _this.toggle();
            });
        } else {
            var toggleController = function toggleController() {
                if (_this.element.classList.contains('dplayer-hide-controller')) {
                    _this.element.classList.remove('dplayer-hide-controller');
                } else {
                    _this.element.classList.add('dplayer-hide-controller');
                }
            };
            videoWrap.addEventListener('click', toggleController);
            conMask.addEventListener('click', toggleController);
        }

        /**
         * Parse second to 00:00 format
         *
         * @param {Number} second
         * @return {String} 00:00 format
         */
        var secondToTime = function secondToTime(second) {
            var add0 = function add0(num) {
                return num < 10 ? '0' + num : '' + num;
            };
            var min = parseInt(second / 60);
            var sec = parseInt(second - min * 60);
            return add0(min) + ':' + add0(sec);
        };

        /**
         * control play progress
         */
        // get element's view position
        var getElementViewLeft = function getElementViewLeft(element) {
            var actualLeft = element.offsetLeft;
            var current = element.offsetParent;
            var elementScrollLeft = void 0;
            if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement) {
                while (current !== null) {
                    actualLeft += current.offsetLeft;
                    current = current.offsetParent;
                }
            } else {
                while (current !== null && current !== _this.element) {
                    actualLeft += current.offsetLeft;
                    current = current.offsetParent;
                }
            }
            elementScrollLeft = document.body.scrollLeft + document.documentElement.scrollLeft;
            return actualLeft - elementScrollLeft;
        };

        var getElementViewTop = function getElementViewTop(element) {
            var actualTop = element.offsetTop;
            var current = element.offsetParent;
            var elementScrollTop = void 0;
            if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement) {
                while (current !== null) {
                    actualTop += current.offsetTop;
                    current = current.offsetParent;
                }
            } else {
                while (current !== null && current !== _this.element) {
                    actualTop += current.offsetTop;
                    current = current.offsetParent;
                }
            }
            elementScrollTop = document.body.scrollTop + document.documentElement.scrollTop;
            return actualTop - elementScrollTop;
        };

        var bar = {};
        bar.playedBar = this.element.getElementsByClassName('dplayer-played')[0];
        bar.loadedBar = this.element.getElementsByClassName('dplayer-loaded')[0];
        var pbar = this.element.getElementsByClassName('dplayer-bar-wrap')[0];
        var barWidth = void 0;

        if (this.option.danmaku) {
            this.video.addEventListener('seeking', function () {
                for (var _i2 = 0; _i2 < _this.dan.length; _i2++) {
                    if (_this.dan[_i2].time >= _this.video.currentTime) {
                        _this.danIndex = _i2;
                        return;
                    }
                    _this.danIndex = _this.dan.length;
                }
            });
        }

        var lastPlayPos = 0;
        var currentPlayPos = 0;
        var bufferingDetected = false;
        var danmakuTime = void 0;
        this.setTime = function () {
            _this.playedTime = setInterval(function () {
                // whether the video is buffering
                currentPlayPos = _this.video.currentTime;
                if (!bufferingDetected && currentPlayPos < lastPlayPos + 0.01 && !_this.video.paused) {
                    _this.element.classList.add('dplayer-loading');
                    bufferingDetected = true;
                }
                if (bufferingDetected && currentPlayPos > lastPlayPos + 0.01 && !_this.video.paused) {
                    _this.element.classList.remove('dplayer-loading');
                    bufferingDetected = false;
                }
                lastPlayPos = currentPlayPos;

                _this.updateBar('played', _this.video.currentTime / _this.video.duration, 'width');
                _this.element.getElementsByClassName('dplayer-ptime')[0].innerHTML = secondToTime(_this.video.currentTime);
                _this.trigger('playing');
            }, 100);
            if (_this.option.danmaku && showdan) {
                danmakuTime = setInterval(function () {
                    var item = _this.dan[_this.danIndex];
                    while (item && _this.video.currentTime >= parseFloat(item.time)) {
                        danmakuIn(item.text, item.color, item.type);
                        item = _this.dan[++_this.danIndex];
                    }
                }, 0);
            }
        };
        this.clearTime = function () {
            clearInterval(_this.playedTime);
            if (_this.option.danmaku) {
                clearInterval(danmakuTime);
            }
        };

        pbar.addEventListener('click', function (event) {
            var e = event || window.event;
            barWidth = pbar.clientWidth;
            var percentage = (e.clientX - getElementViewLeft(pbar)) / barWidth;
            percentage = percentage > 0 ? percentage : 0;
            percentage = percentage < 1 ? percentage : 1;
            _this.updateBar('played', percentage, 'width');
            _this.video.currentTime = parseFloat(bar.playedBar.style.width) / 100 * _this.video.duration;
        });

        var thumbMove = function thumbMove(event) {
            var e = event || window.event;
            var percentage = (e.clientX - getElementViewLeft(pbar)) / barWidth;
            percentage = percentage > 0 ? percentage : 0;
            percentage = percentage < 1 ? percentage : 1;
            _this.updateBar('played', percentage, 'width');
            _this.element.getElementsByClassName('dplayer-ptime')[0].innerHTML = secondToTime(percentage * _this.video.duration);
        };

        var thumbUp = function thumbUp() {
            document.removeEventListener('mouseup', thumbUp);
            document.removeEventListener('mousemove', thumbMove);
            _this.video.currentTime = parseFloat(bar.playedBar.style.width) / 100 * _this.video.duration;
            _this.setTime();
        };

        pbar.addEventListener('mousedown', function () {
            barWidth = pbar.clientWidth;
            _this.clearTime();
            document.addEventListener('mousemove', thumbMove);
            document.addEventListener('mouseup', thumbUp);
        });

        /**
         * control volume
         */
        bar.volumeBar = this.element.getElementsByClassName('dplayer-volume-bar-inner')[0];
        var volumeEle = this.element.getElementsByClassName('dplayer-volume')[0];
        var volumeBarWrapWrap = this.element.getElementsByClassName('dplayer-volume-bar-wrap')[0];
        var volumeBarWrap = this.element.getElementsByClassName('dplayer-volume-bar')[0];
        var volumeicon = this.element.getElementsByClassName('dplayer-volume-icon')[0];
        var vWidth = 35;

        this.switchVolumeIcon = function () {
            var volumeicon = _this.element.getElementsByClassName('dplayer-volume-icon')[0];
            if (_this.video.volume >= 0.8) {
                volumeicon.innerHTML = _this.getSVG('volume-up');
            } else if (_this.video.volume > 0) {
                volumeicon.innerHTML = _this.getSVG('volume-down');
            } else {
                volumeicon.innerHTML = _this.getSVG('volume-off');
            }
        };
        var volumeMove = function volumeMove(event) {
            var e = event || window.event;
            var percentage = (e.clientX - getElementViewLeft(volumeBarWrap) - 5.5) / vWidth;
            _this.volume(percentage);
        };
        var volumeUp = function volumeUp() {
            document.removeEventListener('mouseup', volumeUp);
            document.removeEventListener('mousemove', volumeMove);
            volumeEle.classList.remove('dplayer-volume-active');
        };

        volumeBarWrapWrap.addEventListener('click', function (event) {
            var e = event || window.event;
            var percentage = (e.clientX - getElementViewLeft(volumeBarWrap) - 5.5) / vWidth;
            _this.volume(percentage);
        });
        volumeBarWrapWrap.addEventListener('mousedown', function () {
            document.addEventListener('mousemove', volumeMove);
            document.addEventListener('mouseup', volumeUp);
            volumeEle.classList.add('dplayer-volume-active');
        });
        volumeicon.addEventListener('click', function () {
            if (_this.video.muted) {
                _this.video.muted = false;
                _this.switchVolumeIcon();
                _this.updateBar('volume', _this.video.volume, 'width');
            } else {
                _this.video.muted = true;
                volumeicon.innerHTML = _this.getSVG('volume-off');
                _this.updateBar('volume', 0, 'width');
            }
        });

        /**
         * auto hide controller
         */
        var hideTime = 0;
        if (!isMobile) {
            var hideController = function hideController() {
                _this.element.classList.remove('dplayer-hide-controller');
                clearTimeout(hideTime);
                hideTime = setTimeout(function () {
                    if (_this.video.played.length) {
                        _this.element.classList.add('dplayer-hide-controller');
                        closeSetting();
                        closeComment();
                    }
                }, 2000);
            };
            this.element.addEventListener('mousemove', hideController);
            this.element.addEventListener('click', hideController);
        }

        /***
         * setting
         */
        var danOpacity = localStorage.getItem('DPlayer-opacity') || 0.7;
        var settingHTML = {
            'original': "\n                    <div class=\"dplayer-setting-item dplayer-setting-speed\">\n                        <span class=\"dplayer-label\">" + getTran('Speed') + "</span>\n                        <div class=\"dplayer-toggle\">" + this.getSVG('right') + ("     </div>\n                    </div>\n                    <div class=\"dplayer-setting-item dplayer-setting-loop\">\n                        <span class=\"dplayer-label\">" + getTran('Loop') + "</span>\n                        <div class=\"dplayer-toggle\">\n                            <input class=\"dplayer-toggle-setting-input\" type=\"checkbox\" name=\"dplayer-toggle\">\n                            <label for=\"dplayer-toggle\"></label>\n                        </div>\n                    </div>\n                    <div class=\"dplayer-setting-item dplayer-setting-showdan\">\n                        <span class=\"dplayer-label\">" + getTran('Danmaku') + "</span>\n                        <div class=\"dplayer-toggle\">\n                            <input class=\"dplayer-showdan-setting-input\" type=\"checkbox\" name=\"dplayer-toggle-dan\">\n                            <label for=\"dplayer-toggle-dan\"></label>\n                        </div>\n                    </div>\n                    <div class=\"dplayer-setting-item dplayer-setting-danmaku\">\n                        <span class=\"dplayer-label\">" + getTran('Opacity for danmaku') + "</span>\n                        <div class=\"dplayer-danmaku-bar-wrap\">\n                            <div class=\"dplayer-danmaku-bar\">\n                                <div class=\"dplayer-danmaku-bar-inner\" style=\"width: " + danOpacity * 100 + "%\">\n                                    <span class=\"dplayer-thumb\"></span>\n                                </div>\n                            </div>\n                        </div>\n                    </div>"),
            'speed': "\n                    <div class=\"dplayer-setting-speed-item\" data-speed=\"0.5\">\n                        <span class=\"dplayer-label\">0.5</span>\n                    </div>\n                    <div class=\"dplayer-setting-speed-item\" data-speed=\"0.75\">\n                        <span class=\"dplayer-label\">0.75</span>\n                    </div>\n                    <div class=\"dplayer-setting-speed-item\" data-speed=\"1\">\n                        <span class=\"dplayer-label\">" + getTran('Normal') + "</span>\n                    </div>\n                    <div class=\"dplayer-setting-speed-item\" data-speed=\"1.25\">\n                        <span class=\"dplayer-label\">1.25</span>\n                    </div>\n                    <div class=\"dplayer-setting-speed-item\" data-speed=\"1.5\">\n                        <span class=\"dplayer-label\">1.5</span>\n                    </div>\n                    <div class=\"dplayer-setting-speed-item\" data-speed=\"2\">\n                        <span class=\"dplayer-label\">2</span>\n                    </div>"
        };

        // toggle setting box
        var settingIcon = this.element.getElementsByClassName('dplayer-setting-icon')[0];
        var settingBox = this.element.getElementsByClassName('dplayer-setting-box')[0];
        var mask = this.element.getElementsByClassName('dplayer-mask')[0];
        settingBox.innerHTML = settingHTML.original;

        var closeSetting = function closeSetting() {
            if (settingBox.classList.contains('dplayer-setting-box-open')) {
                settingBox.classList.remove('dplayer-setting-box-open');
                mask.classList.remove('dplayer-mask-show');
                setTimeout(function () {
                    settingBox.classList.remove('dplayer-setting-box-narrow');
                    settingBox.innerHTML = settingHTML.original;
                    settingEvent();
                }, 300);
            }
        };
        var openSetting = function openSetting() {
            settingBox.classList.add('dplayer-setting-box-open');
            mask.classList.add('dplayer-mask-show');
        };

        mask.addEventListener('click', function () {
            closeSetting();
        });
        settingIcon.addEventListener('click', function () {
            openSetting();
        });

        var loop = this.option.loop;
        var danContainer = this.element.getElementsByClassName('dplayer-danmaku')[0];
        var showdan = true;
        var settingEvent = function settingEvent() {
            // loop control
            var loopEle = _this.element.getElementsByClassName('dplayer-setting-loop')[0];
            var loopToggle = loopEle.getElementsByClassName('dplayer-toggle-setting-input')[0];

            loopToggle.checked = loop;

            loopEle.addEventListener('click', function () {
                loopToggle.checked = !loopToggle.checked;
                if (loopToggle.checked) {
                    loop = true;
                    _this.video.loop = loop;
                } else {
                    loop = false;
                    _this.video.loop = loop;
                }
                closeSetting();
            });

            // show danmaku control
            var showDanEle = _this.element.getElementsByClassName('dplayer-setting-showdan')[0];
            var showDanToggle = showDanEle.getElementsByClassName('dplayer-showdan-setting-input')[0];

            showDanToggle.checked = showdan;

            showDanEle.addEventListener('click', function () {
                showDanToggle.checked = !showDanToggle.checked;
                if (showDanToggle.checked) {
                    showdan = true;
                    if (_this.option.danmaku) {
                        for (var _i3 = 0; _i3 < _this.dan.length; _i3++) {
                            if (_this.dan[_i3].time >= _this.video.currentTime) {
                                _this.danIndex = _i3;
                                break;
                            }
                            _this.danIndex = _this.dan.length;
                        }
                        danmakuTime = setInterval(function () {
                            var item = _this.dan[_this.danIndex];
                            while (item && _this.video.currentTime >= parseFloat(item.time)) {
                                danmakuIn(item.text, item.color, item.type);
                                item = _this.dan[++_this.danIndex];
                            }
                        }, 0);
                    }
                } else {
                    showdan = false;
                    if (_this.option.danmaku) {
                        clearInterval(danmakuTime);
                        danContainer.innerHTML = "<div class=\"dplayer-danmaku-item  dplayer-danmaku-item--demo\"></div>";
                        _this.danTunnel = {
                            right: {},
                            top: {},
                            bottom: {}
                        };
                        _this.itemDemo = _this.element.getElementsByClassName('dplayer-danmaku-item')[0];
                    }
                }
                closeSetting();
            });

            // speed control
            var speedEle = _this.element.getElementsByClassName('dplayer-setting-speed')[0];
            speedEle.addEventListener('click', function () {
                settingBox.classList.add('dplayer-setting-box-narrow');
                settingBox.innerHTML = settingHTML.speed;

                var speedItem = settingBox.getElementsByClassName('dplayer-setting-speed-item');

                var _loop = function _loop(_i4) {
                    speedItem[_i4].addEventListener('click', function () {
                        _this.video.playbackRate = speedItem[_i4].dataset.speed;
                        closeSetting();
                    });
                };

                for (var _i4 = 0; _i4 < speedItem.length; _i4++) {
                    _loop(_i4);
                }
            });

            if (_this.option.danmaku) {
                // danmaku opacity
                bar.danmakuBar = _this.element.getElementsByClassName('dplayer-danmaku-bar-inner')[0];
                var danmakuBarWrapWrap = _this.element.getElementsByClassName('dplayer-danmaku-bar-wrap')[0];
                var danmakuBarWrap = _this.element.getElementsByClassName('dplayer-danmaku-bar')[0];
                var danmakuSettingBox = _this.element.getElementsByClassName('dplayer-setting-danmaku')[0];
                var dWidth = 130;
                _this.updateBar('danmaku', danOpacity, 'width');

                var danmakuMove = function danmakuMove(event) {
                    var e = event || window.event;
                    var percentage = (e.clientX - getElementViewLeft(danmakuBarWrap)) / dWidth;
                    percentage = percentage > 0 ? percentage : 0;
                    percentage = percentage < 1 ? percentage : 1;
                    _this.updateBar('danmaku', percentage, 'width');
                    var items = _this.element.getElementsByClassName('dplayer-danmaku-item');
                    for (var _i5 = 0; _i5 < items.length; _i5++) {
                        items[_i5].style.opacity = percentage;
                    }
                    danOpacity = percentage;
                    localStorage.setItem('DPlayer-opacity', danOpacity);
                };
                var danmakuUp = function danmakuUp() {
                    document.removeEventListener('mouseup', danmakuUp);
                    document.removeEventListener('mousemove', danmakuMove);
                    danmakuSettingBox.classList.remove('dplayer-setting-danmaku-active');
                };

                danmakuBarWrapWrap.addEventListener('click', function (event) {
                    var e = event || window.event;
                    var percentage = (e.clientX - getElementViewLeft(danmakuBarWrap)) / dWidth;
                    percentage = percentage > 0 ? percentage : 0;
                    percentage = percentage < 1 ? percentage : 1;
                    _this.updateBar('danmaku', percentage, 'width');
                    var items = _this.element.getElementsByClassName('dplayer-danmaku-item');
                    for (var _i6 = 0; _i6 < items.length; _i6++) {
                        items[_i6].style.opacity = percentage;
                    }
                    danOpacity = percentage;
                    localStorage.setItem('DPlayer-opacity', danOpacity);
                });
                danmakuBarWrapWrap.addEventListener('mousedown', function () {
                    document.addEventListener('mousemove', danmakuMove);
                    document.addEventListener('mouseup', danmakuUp);
                    danmakuSettingBox.classList.add('dplayer-setting-danmaku-active');
                });
            }
        };
        settingEvent();

        /**
         * video events
         */
        // show video time: the metadata has loaded or changed
        this.video.addEventListener('durationchange', function () {
            if (_this.video.duration !== 1) {
                // compatibility: Android browsers will output 1 at first
                _this.element.getElementsByClassName('dplayer-dtime')[0].innerHTML = secondToTime(_this.video.duration);
            }
        });

        // show video loaded bar: to inform interested parties of progress downloading the media
        this.video.addEventListener('progress', function () {
            var percentage = _this.video.buffered.length ? _this.video.buffered.end(_this.video.buffered.length - 1) / _this.video.duration : 0;
            _this.updateBar('loaded', percentage, 'width');
        });

        // video download error: an error occurs
        this.video.addEventListener('error', function () {
            _this.element.getElementsByClassName('dplayer-ptime')[0].innerHTML = "Error happens \u2565\uFE4F\u2565";
            _this.trigger('pause');
        });

        // video can play: enough data is available that the media can be played
        this.video.addEventListener('canplay', function () {
            _this.trigger('canplay');
        });

        // music end
        this.ended = false;
        this.video.addEventListener('ended', function () {
            _this.updateBar('played', 1, 'width');
            if (!loop) {
                _this.ended = true;
                _this.pause();
                _this.trigger('ended');
            }
        });

        this.video.addEventListener('play', function () {
            if (_this.paused) {
                _this.play();
            }
        });

        this.video.addEventListener('pause', function () {
            if (!_this.paused) {
                _this.pause();
            }
        });

        // control volume
        this.video.volume = parseInt(this.element.getElementsByClassName('dplayer-volume-bar-inner')[0].style.width) / 100;

        // loop
        this.video.loop = loop;

        // set duration time
        if (this.video.duration !== 1) {
            // compatibility: Android browsers will output 1 at first
            this.element.getElementsByClassName('dplayer-dtime')[0].innerHTML = this.video.duration ? secondToTime(this.video.duration) : '00:00';
        }

        /**
         * danmaku display
         */
        var itemHeight = arrow ? 24 : 30;
        var danWidth = void 0;
        var danHeight = void 0;
        var itemY = void 0;
        this.danTunnel = {
            right: {},
            top: {},
            bottom: {}
        };

        var danItemRight = function danItemRight(ele) {
            return danContainer.getBoundingClientRect().right - ele.getBoundingClientRect().right;
        };

        var danSpeed = function danSpeed(width) {
            return (danWidth + width) / 5;
        };

        var getTunnel = function getTunnel(ele, type, width) {
            var tmp = danWidth / danSpeed(width);

            var _loop2 = function _loop2(_i7) {
                var item = _this.danTunnel[type][_i7 + ''];
                if (item && item.length) {
                    for (var j = 0; j < item.length; j++) {
                        var danRight = danItemRight(item[j]) - 10;
                        if (danRight <= danWidth - tmp * danSpeed(item[j].offsetWidth) || danRight <= 0) {
                            break;
                        }
                        if (j === item.length - 1) {
                            _this.danTunnel[type][_i7 + ''].push(ele);
                            ele.addEventListener('animationend', function () {
                                _this.danTunnel[type][_i7 + ''].splice(0, 1);
                            });
                            return {
                                v: _i7 % itemY
                            };
                        }
                    }
                } else {
                    _this.danTunnel[type][_i7 + ''] = [ele];
                    ele.addEventListener('animationend', function () {
                        _this.danTunnel[type][_i7 + ''].splice(0, 1);
                    });
                    return {
                        v: _i7 % itemY
                    };
                }
            };

            for (var _i7 = 0;; _i7++) {
                var _ret2 = _loop2(_i7);

                if ((typeof _ret2 === "undefined" ? "undefined" : _typeof(_ret2)) === "object") return _ret2.v;
            }
        };

        this.itemDemo = this.element.getElementsByClassName('dplayer-danmaku-item')[0];

        var danmakuIn = function danmakuIn(text, color, type) {
            danWidth = danContainer.offsetWidth;
            danHeight = danContainer.offsetHeight;
            itemY = parseInt(danHeight / itemHeight);
            var item = document.createElement("div");
            item.classList.add("dplayer-danmaku-item");
            item.classList.add("dplayer-danmaku-" + type);
            item.innerHTML = text;
            item.style.opacity = danOpacity;
            item.style.color = color;
            item.addEventListener('animationend', function () {
                danContainer.removeChild(item);
            });

            // measure
            _this.itemDemo.innerHTML = text;
            var itemWidth = _this.itemDemo.offsetWidth;

            // adjust
            switch (type) {
                case 'right':
                    item.style.top = itemHeight * getTunnel(item, type, itemWidth) + 'px';
                    item.style.width = itemWidth + 1 + 'px';
                    item.style.transform = "translateX(-" + danWidth + "px)";
                    break;
                case 'top':
                    item.style.top = itemHeight * getTunnel(item, type) + 'px';
                    break;
                case 'bottom':
                    item.style.bottom = itemHeight * getTunnel(item, type) + 'px';
                    break;
                default:
                    console.error("Can't handled danmaku type: " + type);
            }

            // insert
            danContainer.appendChild(item);

            // move
            item.classList.add("dplayer-danmaku-move");

            return item;
        };

        // danmaku
        if (this.option.danmaku) {
            this.danIndex = 0;
            this.readDanmaku();
        } else {
            // autoplay
            if (this.option.autoplay && !isMobile) {
                this.play();
            } else if (isMobile) {
                this.pause();
            }
        }

        /**
         * comment
         */
        var commentInput = this.element.getElementsByClassName('dplayer-comment-input')[0];
        var commentIcon = this.element.getElementsByClassName('dplayer-comment-icon')[0];
        var commentBox = this.element.getElementsByClassName('dplayer-comment-box')[0];
        var commentSettingIcon = this.element.getElementsByClassName('dplayer-comment-setting-icon')[0];
        var commentSettingBox = this.element.getElementsByClassName('dplayer-comment-setting-box')[0];
        var commentSendIcon = this.element.getElementsByClassName('dplayer-send-icon')[0];

        var htmlEncode = function htmlEncode(str) {
            return str.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;").replace(/\//g, "&#x2f;");
        };

        var sendComment = function sendComment() {
            commentInput.blur();

            // text can't be empty
            if (!commentInput.value.replace(/^\s+|\s+$/g, '')) {
                alert(getTran('Please input danmaku!'));
                return;
            }

            var danmakuData = {
                token: _this.option.danmaku.token,
                player: _this.option.danmaku.id,
                author: 'DIYgod',
                time: _this.video.currentTime,
                text: commentInput.value,
                color: _this.element.querySelector('.dplayer-comment-setting-color input:checked').value,
                type: _this.element.querySelector('.dplayer-comment-setting-type input:checked').value
            };
            _this.option.apiBackend.send(_this.option.danmaku.api, danmakuData);

            commentInput.value = '';
            closeComment();
            _this.dan.splice(_this.danIndex, 0, danmakuData);
            _this.danIndex++;
            var item = danmakuIn(htmlEncode(danmakuData.text), danmakuData.color, danmakuData.type);
            item.style.border = "2px solid " + _this.option.theme;
        };

        var closeCommentSetting = function closeCommentSetting() {
            if (commentSettingBox.classList.contains('dplayer-comment-setting-open')) {
                commentSettingBox.classList.remove('dplayer-comment-setting-open');
            }
        };
        var toggleCommentSetting = function toggleCommentSetting() {
            if (commentSettingBox.classList.contains('dplayer-comment-setting-open')) {
                commentSettingBox.classList.remove('dplayer-comment-setting-open');
            } else {
                commentSettingBox.classList.add('dplayer-comment-setting-open');
            }
        };

        var disableHide = 0;
        var closeComment = function closeComment() {
            if (commentBox.classList.contains('dplayer-comment-box-open')) {
                commentBox.classList.remove('dplayer-comment-box-open');
                mask.classList.remove('dplayer-mask-show');
                clearInterval(disableHide);
                _this.element.classList.remove('dplayer-show-controller');
                closeCommentSetting();
            }
        };
        var openComment = function openComment() {
            commentBox.classList.add('dplayer-comment-box-open');
            mask.classList.add('dplayer-mask-show');
            disableHide = setInterval(function () {
                clearTimeout(hideTime);
            }, 1000);
            _this.element.classList.add('dplayer-show-controller');
        };

        mask.addEventListener('click', function () {
            closeComment();
        });
        commentIcon.addEventListener('click', function () {
            openComment();
            setTimeout(function () {
                commentInput.focus();
            }, 300);
        });
        commentSettingIcon.addEventListener('click', function () {
            toggleCommentSetting();
        });

        // comment setting box
        this.element.getElementsByClassName('dplayer-comment-setting-color')[0].addEventListener('click', function () {
            var sele = _this.element.querySelector('input[name="dplayer-danmaku-color-${index}"]:checked+span');
            if (sele) {
                commentSettingIcon.getElementsByClassName('dplayer-fill')[0].style.fill = _this.element.querySelector('input[name="dplayer-danmaku-color-${index}"]:checked').value;
            }
        });

        commentInput.addEventListener('click', function () {
            closeCommentSetting();
        });
        commentInput.addEventListener('keydown', function (e) {
            var event = e || window.event;
            if (event.keyCode === 13) {
                sendComment();
            }
        });

        commentSendIcon.addEventListener('click', sendComment);

        /**
         * full screen
         */
        var resetAnimation = function resetAnimation() {
            danWidth = danContainer.offsetWidth;
            var items = _this.element.getElementsByClassName('dplayer-danmaku-item');
            for (var _i8 = 0; _i8 < items.length; _i8++) {
                items[_i8].style.transform = "translateX(-" + danWidth + "px)";
            }
        };

        this.element.addEventListener('fullscreenchange', function () {
            resetAnimation();
        });
        this.element.addEventListener('mozfullscreenchange', function () {
            resetAnimation();
        });
        this.element.addEventListener('webkitfullscreenchange', function () {
            resetAnimation();
        });
        this.element.getElementsByClassName('dplayer-full-icon')[0].addEventListener('click', function () {
            if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement) {
                if (_this.element.requestFullscreen) {
                    _this.element.requestFullscreen();
                } else if (_this.element.mozRequestFullScreen) {
                    _this.element.mozRequestFullScreen();
                } else if (_this.element.webkitRequestFullscreen) {
                    _this.element.webkitRequestFullscreen();
                } else if (_this.video.webkitEnterFullscreen) {
                    // Safari for iOS
                    _this.video.webkitEnterFullscreen();
                }
            } else {
                if (document.cancelFullScreen) {
                    document.cancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                }
            }
            resetAnimation();
        });

        /**
         * hot key
         */
        var handleKeyDown = function handleKeyDown(e) {
            var tag = document.activeElement.tagName.toUpperCase();
            var editable = document.activeElement.getAttribute('contenteditable');
            if (tag !== 'INPUT' && tag !== 'TEXTAREA' && editable !== '' && editable !== 'true') {
                var event = e || window.event;
                var percentage = void 0;
                switch (event.keyCode) {
                    case 32:
                        event.preventDefault();
                        _this.toggle();
                        break;
                    case 37:
                        event.preventDefault();
                        _this.video.currentTime = _this.video.currentTime - 5;
                        break;
                    case 39:
                        event.preventDefault();
                        _this.video.currentTime = _this.video.currentTime + 5;
                        break;
                    case 38:
                        event.preventDefault();
                        percentage = _this.video.volume + 0.1;
                        _this.volume(percentage);
                        break;
                    case 40:
                        event.preventDefault();
                        percentage = _this.video.volume - 0.1;
                        _this.volume(percentage);
                        break;
                }
            }
        };
        if (this.option.hotkey) {
            document.addEventListener('keydown', handleKeyDown);
        }

        /**
         * right key
         */
        var menu = this.element.getElementsByClassName('dplayer-menu')[0];
        this.element.addEventListener('contextmenu', function (e) {
            var event = e || window.event;
            event.preventDefault();

            menu.classList.add('dplayer-menu-show');

            var clientRect = _this.element.getBoundingClientRect();
            var menuLeft = event.clientX - clientRect.left;
            var menuTop = event.clientY - clientRect.top;
            if (menuLeft + menu.offsetWidth >= clientRect.width) {
                menu.style.right = clientRect.width - menuLeft + 'px';
                menu.style.left = 'initial';
            } else {
                menu.style.left = event.clientX - _this.element.getBoundingClientRect().left + 'px';
                menu.style.right = 'initial';
            }
            if (menuTop + menu.offsetHeight >= clientRect.height) {
                menu.style.bottom = clientRect.height - menuTop + 'px';
                menu.style.top = 'initial';
            } else {
                menu.style.top = event.clientY - _this.element.getBoundingClientRect().top + 'px';
                menu.style.bottom = 'initial';
            }

            mask.classList.add('dplayer-mask-show');
            mask.addEventListener('click', function () {
                mask.classList.remove('dplayer-mask-show');
                menu.classList.remove('dplayer-menu-show');
            });
        });

        /**
         * Screenshot
         */
        if (this.option.screenshot) {
            var camareIcon = this.element.getElementsByClassName('dplayer-camera-icon')[0];
            camareIcon.addEventListener('click', function () {
                var canvas = document.createElement("canvas");
                canvas.width = _this.video.videoWidth;
                canvas.height = _this.video.videoHeight;
                canvas.getContext('2d').drawImage(_this.video, 0, 0, canvas.width, canvas.height);

                camareIcon.href = canvas.toDataURL();
                camareIcon.download = "DPlayer.png";
            });
        }

        index++;
    }

    /**
     * Play music
     */


    _createClass(DPlayer, [{
        key: "play",
        value: function play(time) {
            if (Object.prototype.toString.call(time) === '[object Number]') {
                this.video.currentTime = time;
            }
            this.paused = false;
            if (this.video.paused) {
                this.bezel.innerHTML = this.getSVG('play');
                this.bezel.classList.add('dplayer-bezel-transition');
            }

            this.playButton.innerHTML = this.getSVG('pause');

            this.video.play();
            if (this.playedTime) {
                this.clearTime();
            }
            this.setTime();
            this.element.classList.add('dplayer-playing');
            this.trigger('play');
        }

        /**
         * Pause music
         */

    }, {
        key: "pause",
        value: function pause() {
            this.paused = true;
            this.element.classList.remove('dplayer-loading');

            if (!this.video.paused) {
                this.bezel.innerHTML = this.getSVG('pause');
                this.bezel.classList.add('dplayer-bezel-transition');
            }

            this.ended = false;
            this.playButton.innerHTML = this.getSVG('play');
            this.video.pause();
            this.clearTime();
            this.element.classList.remove('dplayer-playing');
            this.trigger('pause');
        }

        /**
         * Set volume
         */

    }, {
        key: "volume",
        value: function volume(percentage) {
            percentage = percentage > 0 ? percentage : 0;
            percentage = percentage < 1 ? percentage : 1;
            this.updateBar('volume', percentage, 'width');
            this.video.volume = percentage;
            if (this.video.muted) {
                this.video.muted = false;
            }
            this.switchVolumeIcon();
        }

        /**
         * Toggle between play and pause
         */

    }, {
        key: "toggle",
        value: function toggle() {
            if (this.video.paused) {
                this.play();
            } else {
                this.pause();
            }
        }

        /**
         * attach event
         */

    }, {
        key: "on",
        value: function on(name, func) {
            if (typeof func === 'function') {
                this.event[name].push(func);
            }
        }

        /**
         * Asynchronously read danmaku from all API endpoints
         */

    }, {
        key: "_readAllEndpoints",
        value: function _readAllEndpoints(endpoints, finish) {
            var results = [];
            var readCount = 0;
            var cbk = function cbk(i) {
                return function (err, data) {
                    ++readCount;
                    if (err) {
                        if (err.response) alert(err.response.msg);else console.log('Request was unsuccessful: ' + err.status);
                        results[i] = [];
                    } else {
                        results[i] = data;
                    }
                    if (readCount == endpoints.length) {
                        return finish(results);
                    }
                };
            };

            for (var i = 0; i < endpoints.length; ++i) {
                this.option.apiBackend.read(endpoints[i], cbk(i));
            }
        }

        /**
         * Read danmaku from API
         */

    }, {
        key: "readDanmaku",
        value: function readDanmaku() {
            var _this2 = this;

            var isMobile = /mobile/i.test(window.navigator.userAgent);
            var apiurl = void 0;
            if (this.option.danmaku.maximum) {
                apiurl = this.option.danmaku.api + "?id=" + this.option.danmaku.id + "&max=" + this.option.danmaku.maximum;
            } else {
                apiurl = this.option.danmaku.api + "?id=" + this.option.danmaku.id;
            }
            var endpoints = (this.option.danmaku.addition || []).slice(0);
            endpoints.push(apiurl);

            this._readAllEndpoints(endpoints, function (results) {
                _this2.danIndex = 0;
                _this2.dan = [].concat.apply([], results).sort(function (a, b) {
                    return a.time - b.time;
                });
                _this2.element.getElementsByClassName('dplayer-danloading')[0].style.display = 'none';

                // autoplay
                if (_this2.option.autoplay && !isMobile) {
                    _this2.play();
                } else if (isMobile) {
                    _this2.pause();
                }
            });
        }

        /**
         * Switch to a new video
         *
         * @param {Object} video - new video info
         * @param {Object} danmaku - new danmaku info
         */

    }, {
        key: "switchVideo",
        value: function switchVideo(video, danmaku) {
            this.video.src = video.url;
            this.video.poster = video.pic ? video.pic : '';
            this.video.currentTime = 0;
            this.pause();
            if (danmaku) {
                this.dan = [];
                this.danIndex = 0;
                this.element.getElementsByClassName('dplayer-danloading')[0].style.display = 'block';
                this.updateBar('played', 0, 'width');
                this.updateBar('loaded', 0, 'width');
                this.element.getElementsByClassName('dplayer-ptime')[0].innerHTML = '00:00';
                this.element.getElementsByClassName('dplayer-danmaku')[0].innerHTML = "<div class=\"dplayer-danmaku-item  dplayer-danmaku-item--demo\"></div>";
                this.danTunnel = {
                    right: {},
                    top: {},
                    bottom: {}
                };
                this.itemDemo = this.element.getElementsByClassName('dplayer-danmaku-item')[0];
                this.option.danmaku = danmaku;
                this.readDanmaku();
            }
        }
    }]);

    return DPlayer;
}();

module.exports = DPlayer;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// DPlayer.min.js